var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 450 426.4",
    style: {
      enableBackground: "new 0 0 450 426.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E5F3F9;}\n\t.st1{fill:#BEE1F4;}\n\t.st2{fill:#529ADA;}\n\t.st3{fill:#06325B;}\n\t.st4{fill:#0569BD;}\n\t.st5{fill:#83BDF0;}\n\t.st6{fill:#0A81ED;}\n\t.st7{fill:#3885CA;}\n\t.st8{fill:#FFC8AF;}\n\t.st9{fill:#F4AE92;}\n\t.st10{fill:#112B46;}\n\t.st11{fill:#043059;}\n\t.st12{fill:#83C9FF;}\n\t.st13{fill:#1371C0;}\n\t.st14{enable-background:new    ;}\n\t.st15{fill:#64BB46;}\n\t.st16{fill:#4B9B2D;}\n\t.st17{fill:#9ADB82;}\n\t.st18{fill:#0669BF;}\n\t.st19{fill:#2EB2E7;}\n\t.st20{fill:#495DEA;}\n\t.st21{fill:#FFDC85;}\n\t.st22{fill:#F2AD91;}\n\t.st23{fill:none;}\n\t.st24{fill:#FFFFFF;}\n\t.st25{fill:#EC827D;}\n\t.st26{fill:#CCD9E2;}\n\t.st27{fill:#A5B7C6;}\n\t.st28{fill:#B6C7D3;}\n\t.st29{fill:#FBD15B;}\n\t.st30{fill:#606BF1;}\n\t.st31{fill:#879FAF;}\n\t.st32{fill:#56548C;}\n\t.st33{fill:#00C3B6;}\n\t.st34{fill:#EEEEEE;}\n\t.st35{fill:#CECCFF;}\n\t.st36{fill:#EAEEEF;}\n\t.st37{font-family:'OpenSans-Semibold';}\n\t.st38{font-size:9.3751px;}\n\t.st39{font-size:11.1476px;}\n\t.st40{fill:#4190D7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M318.8,176.3c3.2,3.1,7.8,4.7,12.3,4.6c5.2-0.2,10.2-2.5,14.2-5.8c0.1-0.1,0.2-0.2,0.3-0.3 c-1,0-1.9-0.1-2.9-0.2c-4.4-0.4-9-0.9-12.8-2.9c6.7,1.1,13.8,0.5,20.2-1.7c2.4-3,4.2-6.4,5.5-10c-0.8,0.5-1.7,1-2.5,1.3 c-5.8,2.7-12.4,2.7-18.7,1.7c8.1-2,15.8-5.1,23-9.3c0.5-3,0.7-6,0.4-9c-0.8,0.8-1.5,1.7-2.2,2.6c-1.3,1.8-2.3,3.8-4,5.2 c-2.3,1.9-5.5,2.1-8.5,2.2c-1.5,0-3,0.1-4.6,0c1.8-0.6,3.6-1.3,5.4-2.1c1.6-0.6,3.1-1.3,4.6-2.2c3.7-2.2,6.4-5.5,8.9-9.1 c-0.3-1.9-0.8-3.7-1.5-5.5c-3.9,3.7-8.5,6.7-13.5,8.7c4.5-3.4,8.7-7.3,12.2-11.6c-0.7-1.6-1.6-3-2.6-4.5 c-3.3,4.1-7.7,7.3-12.5,9.4c4.1-3.4,7.6-7.7,10.2-12.4c-0.9-1-1.8-2-2.7-2.9c-0.8,1-1.7,1.9-2.7,2.7c-0.8,0.7-1.8,1.3-2.7,1.8 c1.4-1.9,2.6-4,3.6-6.2c-1.3-1.1-2.6-2.2-4-3.1L318.8,176.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M318.8,176.3c-2.3,0.6-6.5,0.1-8.7-0.9c-2.4-1.1-4.7-2.7-6.5-4.7c-3.5-3.9-4.9-9.3-5.4-14.5 c1.9,1.7,3.9,3.2,6.2,4.4c2.3,1.2,4.8,2,7.3,2.9c-2.5-2.5-4.7-5.3-7.5-7.4c-1-0.8-2-1.5-2.9-2.3c-1.3-1.1-2.3-2.4-3.2-3.9 c0.3-4.1,1.2-8.2,2.9-12c0.6,1.9,1.5,3.7,2.3,5.5c1,2,2.1,4,3.6,5.5c1.2,1.2,2.6,2.1,4.1,2.8c-0.9-0.9-1.7-1.9-2.4-3 c-3.1-4.7-4-10.4-4.7-16c1.2-1.7,2.7-3.2,4.2-4.6c0.4,3.6,1.4,7.1,3,10.4c1.5,3,3.5,5.7,5.9,8c-0.5-0.9-0.9-1.8-1.3-2.7 c-1.3-2.8-2.5-5.7-3.3-8.7c-0.5-1.8-0.8-3.7-1-5.6c-0.1-0.9-0.2-1.9-0.2-2.8c0-0.4,0-0.7,0.1-1.1c1.7-1.2,3.5-2.3,5.4-3.2 c-0.4,2.5-0.5,4.9,0,7.4c0.3,1.5,0.8,2.9,1.4,4.3c1.2,2.9,2.7,5.6,4.7,8.1c-3.2-6.7-4.1-14.6-1.8-21.6c1.4-0.5,2.8-0.9,4.2-1.2 c-0.5,2.9-0.5,5.9,0.1,8.8c0.2-3.2,1.1-6.4,2.6-9.2c1.6-0.2,3.3-0.4,4.9-0.5c-0.3,1.8-0.4,3.7-0.2,5.6c0.4-2,1.1-3.9,2.1-5.7 c2-0.1,4.1-0.3,6.3-0.5L318.8,176.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M326,167.2c1.2,0.1,2.3,0.2,3.5,0.2c2.3,0.1,4.7,0.2,7,0.1c2.3-0.1,4.7-0.2,7-0.4c2.3-0.3,4.6-0.6,6.9-1.1 c-2.3,0.5-4.6,0.8-6.9,1s-4.6,0.2-6.9,0.2s-4.6-0.1-6.9-0.3c-1.2-0.1-2.3-0.2-3.5-0.3l-2.6-0.3l2.5-6.9c1.5,0.1,3.1,0.2,4.6,0.1 c1.7-0.1,3.4-0.2,5.1-0.4c3.4-0.4,6.7-1.1,10-2.1c-3.3,0.9-6.6,1.5-10,1.8c-1.7,0.2-3.4,0.2-5.1,0.2c-1.5,0-2.9-0.1-4.3-0.3 l2.4-6.5c2.1-0.1,4.1-0.2,6.1-0.7c2.1-0.5,4.3-1.1,6.3-1.9c2-0.8,4-1.7,5.9-2.8s3.7-2.3,5.5-3.6c-1.7,1.3-3.6,2.5-5.5,3.5 s-3.9,1.9-5.9,2.7s-4.1,1.3-6.3,1.7c-1.9,0.4-3.9,0.5-5.8,0.5l2.5-6.9c1.7-0.4,3.5-0.8,5.1-1.5c1.7-0.7,3.4-1.4,5-2.4 c1.6-0.9,3.2-1.9,4.6-3c1.5-1.1,2.9-2.3,4.2-3.6c-1.3,1.3-2.8,2.4-4.3,3.5s-3.1,2-4.7,2.9s-3.3,1.6-5,2.2 c-1.5,0.6-3.1,0.9-4.7,1.2l2.6-7.2c2.1-1.1,4.1-2.4,6-3.9s3.7-3.2,5.2-5c-1.6,1.8-3.4,3.4-5.3,4.9c-1.8,1.4-3.7,2.5-5.7,3.6 l4.6-12.5l-6.6,16.5c-0.6-1.2-1.2-2.4-1.6-3.7c-0.3-0.7-0.5-1.5-0.7-2.2c-0.2-0.8-0.4-1.5-0.5-2.3c-0.2-1.5-0.4-3.1-0.4-4.6 c0-1.5,0.1-3.1,0.4-4.6c-0.3,1.5-0.4,3.1-0.5,4.6c0,1.6,0.1,3.1,0.3,4.6c0.1,0.8,0.3,1.5,0.4,2.3c0.2,0.8,0.4,1.5,0.6,2.2 c0.4,1.4,1.1,2.8,1.7,4.1l-2.6,6.5c-1.2-1.6-2.3-3.2-3.1-5c-1-1.9-1.8-4-2.4-6.1s-1-4.3-1.2-6.4c-0.2-2.2-0.2-4.4,0.1-6.6 c-0.4,2.2-0.4,4.4-0.3,6.6s0.5,4.4,1.1,6.5s1.3,4.2,2.3,6.2c0.9,1.9,2.1,3.7,3.3,5.4l-2.4,6l-0.8-0.8l-0.6-0.7l-0.6-0.7l-1.2-1.4 l-1.1-1.5c-1.4-2-2.7-4.1-3.8-6.3c-1.1-2.2-2-4.5-2.8-6.9s-1.4-4.8-1.8-7.2c0.3,2.5,0.9,4.9,1.6,7.3c0.7,2.4,1.6,4.7,2.6,7 s2.3,4.4,3.7,6.5l1.1,1.5l1.2,1.5l0.6,0.7l0.6,0.7l1,1l-1.5,3.6c-1.7-1.1-3.4-2.2-4.9-3.5c-1.7-1.5-3.3-3-4.7-4.8 c-1.5-1.7-2.8-3.5-4.1-5.4c-1.2-1.9-2.4-3.8-3.4-5.9c0.9,2.1,2,4,3.2,6c1.2,1.9,2.5,3.8,3.9,5.5c1.4,1.8,3,3.4,4.7,4.9 c1.5,1.4,3.2,2.7,5,3.8l-1.7,4.1c-0.8-0.3-1.6-0.7-2.3-1c-1-0.5-2-0.9-2.9-1.5c-1.9-1-3.8-2.1-5.6-3.3c-1.8-1.2-3.6-2.5-5.2-3.9 c-1.7-1.4-3.3-2.9-4.7-4.5c1.4,1.7,3,3.2,4.6,4.6c1.6,1.4,3.4,2.8,5.2,4.1c1.8,1.2,3.6,2.5,5.5,3.5c0.9,0.6,1.9,1,2.9,1.6 c0.8,0.4,1.6,0.8,2.3,1.1l-3.4,8.5c-1.6-0.2-3.3-0.6-4.8-1.1c-1.8-0.7-3.5-1.6-5.1-2.7c-1.6-1.1-3.1-2.3-4.6-3.6 c-1.4-1.3-2.8-2.7-4-4.2c1.2,1.6,2.5,3,3.9,4.4s2.9,2.6,4.5,3.8c1.6,1.1,3.3,2.1,5.1,2.9c1.5,0.6,3.1,1.1,4.8,1.3l-6,14.8l2.1,0.8 l5.5-15.1c1.2,0.6,2.4,1.1,3.6,1.5c1.5,0.5,3.1,0.9,4.6,1.2c1.6,0.3,3.2,0.5,4.7,0.6c1.6,0.1,3.2,0,4.8-0.2 c-1.6,0.1-3.2,0.1-4.7,0c-1.6-0.1-3.1-0.4-4.7-0.7c-1.5-0.4-3.1-0.8-4.5-1.4c-1.2-0.5-2.4-1-3.5-1.7l2.1-5.9L326,167.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.8,260.6c3.1-3.2,4.6-7.9,4.4-12.3c-0.2-5.2-2.6-10.2-6.1-14.1c-0.1-0.1-0.2-0.2-0.3-0.3 c0,1-0.1,1.9-0.1,2.9c-0.3,4.4-0.7,9-2.7,12.8c1-6.8,0.3-13.8-2-20.2c-3.1-2.3-6.5-4.1-10.1-5.4c0.5,0.8,1,1.6,1.4,2.5 c2.8,5.7,2.9,12.3,2.1,18.7c-2.1-8-5.4-15.7-9.7-22.8c-3-0.5-6-0.6-9-0.3c0.8,0.8,1.7,1.5,2.6,2.2c1.8,1.3,3.9,2.2,5.3,3.9 c1.9,2.3,2.2,5.5,2.3,8.5c0.1,1.5,0.1,3,0.1,4.6c-0.7-1.8-1.4-3.6-2.1-5.3c-0.7-1.6-1.4-3.1-2.3-4.6c-2.3-3.6-5.7-6.3-9.2-8.7 c-1.9,0.4-3.7,0.9-5.5,1.6c3.8,3.8,6.8,8.4,9,13.3c-3.4-4.5-7.4-8.5-11.8-12c-1.6,0.8-3,1.7-4.4,2.7c4.1,3.3,7.5,7.5,9.6,12.4 c-3.5-4.1-7.8-7.5-12.6-9.9c-1,0.9-2,1.8-2.9,2.8c1,0.8,1.9,1.7,2.7,2.6c0.7,0.8,1.3,1.7,1.9,2.7c-1.9-1.4-4-2.6-6.2-3.5 c-1.1,1.3-2.1,2.6-3,4L58.8,260.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.8,260.6c0.7,2.3,0.2,6.5-0.8,8.7c-1.1,2.5-2.6,4.7-4.6,6.6c-3.9,3.6-9.2,5.1-14.4,5.6 c1.7-1.9,3.2-4,4.3-6.3c1.2-2.4,2-4.9,2.7-7.4c-2.4,2.5-5.2,4.8-7.3,7.6c-0.8,1-1.4,2-2.2,3c-1.1,1.3-2.4,2.4-3.8,3.3 c-4.2-0.2-8.3-1-12-2.7c1.9-0.6,3.7-1.5,5.4-2.4c2-1,3.9-2.1,5.5-3.7c1.2-1.2,2-2.7,2.7-4.2c-0.9,0.9-1.9,1.7-2.9,2.4 c-4.6,3.2-10.3,4.2-15.9,5c-1.7-1.2-3.2-2.6-4.6-4.1c3.6-0.4,7.1-1.5,10.3-3.2c2.9-1.5,5.6-3.6,7.9-6c-0.9,0.5-1.8,0.9-2.6,1.3 c-2.8,1.3-5.6,2.6-8.6,3.5c-1.8,0.5-3.7,0.9-5.6,1.1c-0.9,0.1-1.9,0.3-2.8,0.3c-0.4,0-0.7,0-1.1-0.1c-1.2-1.7-2.3-3.5-3.3-5.3 c2.5,0.4,4.9,0.4,7.4-0.2c1.5-0.3,2.9-0.9,4.3-1.5c2.8-1.3,5.6-2.8,8-4.8c-6.6,3.3-14.5,4.3-21.6,2.2c-0.5-1.4-0.9-2.8-1.3-4.2 c2.9,0.5,5.9,0.4,8.8-0.2c-3.2-0.2-6.4-1-9.3-2.5c-0.3-1.6-0.4-3.2-0.6-4.9c1.8,0.3,3.7,0.3,5.6,0.1c-2-0.3-3.9-1-5.7-2 c-0.2-2-0.3-4.1-0.6-6.3L58.8,260.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.7,253.6c0.1-1.2,0.2-2.3,0.2-3.5c0.1-2.3,0.1-4.7,0-7s-0.3-4.6-0.5-7c-0.3-2.3-0.7-4.6-1.3-6.9 c0.5,2.3,0.8,4.6,1.1,6.9c0.2,2.3,0.3,4.6,0.4,6.9c0,2.3,0,4.6-0.2,6.9c-0.1,1.2-0.2,2.3-0.3,3.5l-0.3,2.6l-6.9-2.4 c0.1-1.5,0.1-3.1,0.1-4.6c-0.1-1.7-0.2-3.4-0.5-5.1c-0.5-3.4-1.3-6.7-2.3-9.9c0.9,3.3,1.6,6.6,1.9,10c0.2,1.7,0.3,3.4,0.3,5.1 c0,1.5-0.1,2.9-0.2,4.3l-6.6-2.3c-0.1-2.1-0.3-4.1-0.8-6.1c-0.5-2.1-1.1-4.2-2-6.3c-0.8-2-1.8-4-2.9-5.9s-2.3-3.7-3.7-5.4 c1.3,1.7,2.5,3.6,3.6,5.5s2,3.9,2.8,5.9s1.4,4.1,1.8,6.2c0.4,1.9,0.6,3.9,0.6,5.8l-6.9-2.4c-0.4-1.7-0.9-3.4-1.5-5.1 c-0.7-1.7-1.5-3.4-2.4-5s-2-3.1-3.1-4.6s-2.3-2.8-3.7-4.1c1.3,1.3,2.5,2.7,3.6,4.2s2.1,3,3,4.6s1.7,3.3,2.3,5 c0.6,1.5,1,3.1,1.3,4.7l-7.2-2.5c-1.2-2.1-2.5-4.1-4-5.9c-1.6-1.9-3.2-3.6-5.1-5.1c1.8,1.6,3.5,3.3,5,5.2c1.4,1.8,2.6,3.6,3.7,5.6 L6.4,241l16.6,6.4c-1.2,0.7-2.4,1.3-3.7,1.7c-0.7,0.3-1.5,0.5-2.2,0.7c-0.8,0.2-1.5,0.4-2.3,0.5c-1.5,0.3-3.1,0.4-4.6,0.5 c-1.5,0-3.1-0.1-4.6-0.3c1.5,0.3,3.1,0.4,4.6,0.4c1.6,0,3.1-0.1,4.6-0.4c0.8-0.1,1.5-0.3,2.3-0.5c0.7-0.2,1.5-0.4,2.2-0.7 c1.4-0.5,2.7-1.1,4.1-1.8L30,250c-1.6,1.2-3.2,2.3-4.9,3.2c-1.9,1.1-3.9,1.9-6,2.5c-2.1,0.7-4.2,1.1-6.4,1.3s-4.4,0.3-6.6,0 c2.2,0.3,4.4,0.3,6.6,0.2c2.2-0.2,4.4-0.6,6.5-1.2s4.2-1.4,6.2-2.4c1.9-0.9,3.6-2.1,5.3-3.4l6,2.3l-0.8,0.8l-0.6,0.7l-0.7,0.6 l-1.4,1.2l-1.5,1.1c-2,1.5-4.1,2.8-6.3,3.9s-4.5,2.1-6.8,2.9s-4.7,1.5-7.2,1.9c2.5-0.4,4.9-1,7.2-1.7c2.4-0.8,4.7-1.7,6.9-2.8 c2.2-1.1,4.4-2.3,6.4-3.8l1.5-1.1l1.4-1.2l0.7-0.6l0.7-0.7l1-1l3.6,1.4c-1,1.7-2.2,3.4-3.5,4.9c-1.4,1.7-3,3.3-4.7,4.8 s-3.4,2.9-5.3,4.2c-1.9,1.3-3.8,2.4-5.8,3.5c2-1,4-2.1,5.9-3.3c1.9-1.2,3.7-2.6,5.4-4c1.7-1.4,3.4-3,4.9-4.7 c1.4-1.5,2.6-3.3,3.7-5l4.2,1.6c-0.3,0.8-0.7,1.6-1,2.3c-0.5,1-0.9,2-1.4,2.9c-1,1.9-2.1,3.8-3.2,5.7c-1.2,1.8-2.4,3.6-3.8,5.3 c-1.4,1.7-2.8,3.3-4.4,4.8c1.7-1.4,3.1-3,4.6-4.7c1.4-1.7,2.7-3.4,4-5.2c1.2-1.8,2.4-3.7,3.4-5.6c0.5-0.9,1-1.9,1.5-2.9 c0.4-0.8,0.7-1.6,1.1-2.4l8.5,3.3c-0.2,1.6-0.5,3.3-1.1,4.8c-0.7,1.8-1.6,3.5-2.6,5.2c-1.1,1.6-2.2,3.2-3.5,4.6s-2.7,2.8-4.2,4.1 c1.5-1.2,3-2.5,4.3-3.9s2.6-2.9,3.7-4.5c1.1-1.6,2-3.3,2.8-5.2c0.6-1.5,1-3.1,1.2-4.8l14.9,5.7l0.8-2.1L56,258.7 c0.6-1.2,1.1-2.4,1.5-3.6c0.5-1.5,0.9-3.1,1.2-4.6c0.3-1.6,0.4-3.2,0.5-4.8c0-1.6,0-3.2-0.2-4.8c0.2,1.6,0.2,3.2,0.1,4.7 c-0.1,1.6-0.3,3.1-0.7,4.7c-0.3,1.5-0.8,3.1-1.3,4.5c-0.4,1.2-1,2.4-1.6,3.6l-5.9-2L49.7,253.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1856_",
    className: "st0",
    d: "M250.7,344c-47.4,27.4-124.6,27.2-172.3-0.3s-48-72.1-0.5-99.5s124.6-27.2,172.3,0.3 C297.9,272.1,298.2,316.6,250.7,344z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1855_",
    className: "st0",
    d: "M374.3,295.1c-47.4,27.4-124.6,27.2-172.3-0.3c-47.7-27.6-48-72.1-0.5-99.5 s124.6-27.2,172.3,0.3C421.5,223.2,421.7,267.8,374.3,295.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.5,74.2L174.5,74.2L174.5,74.2c-1.4-0.7-2.8-1.2-4.3-1.7c-0.1,0-0.2,0-0.2-0.1c-0.4-0.1-0.8-0.2-1.2-0.3 c-0.1,0-0.3-0.1-0.4-0.1c-0.3-0.1-0.7-0.2-1.1-0.2c-0.2,0-0.3-0.1-0.5-0.1c-0.3-0.1-0.7-0.1-1-0.1c-0.2,0-0.3,0-0.5-0.1 c-0.4,0-0.7-0.1-1.1-0.1c-0.2,0-0.3,0-0.5,0c-0.5,0-1,0-1.5,0l0,0l0,0c-5.7,0-11,1.7-15.4,4.7c-1.1,0.7-2.1,1.6-3.1,2.5 s-1.9,1.9-2.7,2.9c-0.3,0.3-0.6,0.7-0.8,1c-0.5,0.7-1,1.4-1.5,2.2c-0.2,0.4-0.5,0.8-0.7,1.2c-0.3,0.5-0.5,1-0.8,1.6 s-0.5,1.1-0.7,1.7c-0.4,1-0.7,1.9-0.9,2.9c-0.6,2.2-0.9,4.5-0.9,6.9c0,0.4,0,0.9,0,1.3c0,0.1,0,0.3,0,0.4c0,0.3,0,0.6,0.1,0.9 c0,0.2,0,0.3,0,0.5c0,0.3,0.1,0.6,0.1,0.8c0,0.1,0,0.3,0.1,0.4c0.1,0.3,0.1,0.7,0.2,1c0,0.1,0,0.2,0.1,0.3 c0.1,0.4,0.2,0.7,0.2,1.1c0,0.2,0.1,0.3,0.1,0.5c0.1,0.2,0.1,0.5,0.2,0.7c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0.2,0.1,0.4,0.2,0.6 c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0.2,0.2,0.4,0.2,0.6c0.1,0.4,0.3,0.7,0.5,1.1c0.1,0.2,0.1,0.3,0.2,0.5c0.1,0.2,0.2,0.4,0.3,0.6 c0.1,0.1,0.1,0.3,0.2,0.4c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.1,0.1,0.3,0.2,0.4c0.1,0.2,0.3,0.4,0.4,0.7c0.1,0.1,0.1,0.2,0.2,0.3 c0.3,0.5,0.7,1,1,1.5l0,0l0,0c5,6.8,13.1,11.2,22.2,11.2c15.2,0,27.6-12.3,27.6-27.6C189.9,88.1,183.6,78.8,174.5,74.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93,65.3L93,65.3L93,65.3c-1.9-0.9-3.8-1.7-5.8-2.3c-0.1,0-0.2-0.1-0.3-0.1c-0.5-0.2-1.1-0.3-1.6-0.4 c-0.2,0-0.4-0.1-0.5-0.1c-0.5-0.1-1-0.2-1.4-0.3c-0.2,0-0.4-0.1-0.7-0.1c-0.5-0.1-0.9-0.1-1.4-0.2c-0.2,0-0.5-0.1-0.7-0.1 c-0.5-0.1-1-0.1-1.5-0.1c-0.2,0-0.4,0-0.6,0c-0.7,0-1.4-0.1-2.1-0.1c-20.7,0-37.6,16.8-37.6,37.6c0,0.6,0,1.2,0,1.8 c0,0.2,0,0.4,0,0.6c0,0.4,0.1,0.8,0.1,1.2c0,0.2,0,0.4,0.1,0.6c0,0.4,0.1,0.8,0.1,1.1c0,0.2,0.1,0.4,0.1,0.6 c0.1,0.5,0.2,0.9,0.2,1.4c0,0.2,0.1,0.3,0.1,0.5c0.1,0.5,0.2,1,0.3,1.5c0.1,0.2,0.1,0.5,0.2,0.7c0.1,0.3,0.2,0.6,0.3,0.9 s0.2,0.5,0.2,0.8c0.1,0.3,0.2,0.6,0.3,0.8c0.1,0.3,0.2,0.5,0.3,0.8s0.2,0.5,0.3,0.8c0.2,0.5,0.4,1,0.6,1.5 c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.3,0.3,0.6,0.4,0.9c0.1,0.2,0.2,0.4,0.3,0.6c0.2,0.3,0.3,0.6,0.5,0.9c0.1,0.2,0.2,0.3,0.3,0.5 c0.2,0.3,0.4,0.6,0.5,0.9c0.1,0.1,0.2,0.2,0.2,0.4c6.7,10.5,18.4,17.4,31.7,17.4c20.7,0,37.6-16.8,37.6-37.6 C113.9,84.2,105.4,71.4,93,65.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.1,2c-0.1,0-0.3-0.1-0.4-0.1c-0.7-0.2-1.4-0.4-2.1-0.6c-0.2-0.1-0.5-0.1-0.7-0.2 c-0.6-0.1-1.2-0.3-1.8-0.4c-0.3-0.1-0.6-0.1-0.8-0.1c-0.6-0.1-1.2-0.2-1.8-0.3c-0.3,0-0.6-0.1-0.9-0.1c-0.6-0.1-1.2-0.1-1.9-0.2 c-0.3,0-0.5,0-0.8-0.1c-0.9,0-1.8-0.1-2.7-0.1l0,0l0,0c-9.1,0-17.6,2.5-24.9,6.9c-0.7,0.4-1.3,0.8-1.9,1.2 c-3.8,2.6-7.3,5.7-10.2,9.3c-6.8,8.3-11,18.9-11,30.5c0,0.8,0,1.5,0.1,2.3c0,0.2,0,0.5,0,0.7c0,0.5,0.1,1,0.1,1.5 c0,0.3,0.1,0.5,0.1,0.8c0.1,0.5,0.1,1,0.2,1.5c0,0.3,0.1,0.5,0.1,0.8c0.1,0.6,0.2,1.2,0.3,1.8c0,0.2,0.1,0.4,0.1,0.6 c0.1,0.6,0.3,1.2,0.4,1.9c0.1,0.3,0.2,0.6,0.2,0.9c0.1,0.4,0.2,0.8,0.3,1.2c0.1,0.3,0.2,0.6,0.3,1c0.1,0.4,0.2,0.7,0.4,1.1 c0.1,0.3,0.2,0.7,0.4,1c0.1,0.3,0.3,0.7,0.4,1c0.3,0.6,0.5,1.3,0.8,1.9c0.1,0.3,0.2,0.5,0.4,0.8c0.2,0.4,0.4,0.7,0.6,1.1 c0.1,0.2,0.2,0.5,0.4,0.7c0.2,0.4,0.4,0.8,0.6,1.1c0.1,0.2,0.2,0.4,0.4,0.6c0.2,0.4,0.4,0.8,0.7,1.1c0.1,0.2,0.2,0.3,0.3,0.5 c8.5,13.4,23.5,22.3,40.5,22.3c26.5,0,48-21.5,48-48C172.3,26.3,157.9,8,138.1,2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "162.3,101.6 126.4,121.1 124.3,61.8 121.8,132.8 78.3,99 121.6,139 119.8,191.3 128.8,191.3  126.6,126.7  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1854_",
    className: "st0",
    d: "M355.5,376.3c-47.4,27.4-124.6,27.2-172.3-0.3c-47.7-27.6-48-72.1-0.5-99.5 c47.4-27.4,124.6-27.2,172.3,0.3C402.7,304.4,402.9,348.9,355.5,376.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1853_",
    className: "st0",
    d: "M404.6,371.9c-27.1,15.6-71.1,15.5-98.3-0.2s-27.4-41.1-0.3-56.8 c27.1-15.6,71.1-15.5,98.3,0.2C431.5,330.8,431.6,356.3,404.6,371.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M412.9,299.3c-1.2,2-2.4,3.9-3.7,5.8c-0.3,0.5-0.9,0.9-0.9,1.5c0.1,0.7,1.2,1.7,1.6,2.3 c0.6,0.7,1.5,2.4,2.3,2.9c-1-0.5-3.1-2-4.5-2c0.1,0.9,0.7,1.9,1,2.8c-0.9-0.7-1.6-1.1-2.7-1.3c0.2,0.9-0.4,2.1-0.5,3 c-0.9,4.5-1.6,9.9,0.4,14.1c2.2,4.6,8.4,3.9,12.5,2.9c2.1-0.5,4.2-1.4,6-2.6c0.6-0.5,2.8-2.7,3.7-2c-0.3-0.9-0.6-1.8-0.7-2.7 c0.6,0.4,1.5,0.3,1.9,0.8c1-0.7,1.6-2,2.8-2.6c-0.9-1-1.2-2.6-2-3.7c1.1,0.1,2.4,0.4,3.5,0.9c0.3-0.7,0.8-1.4,1.3-2 c2-2.7,3.7-5.8,5.2-8.8c0.9-1.9,2-3.6,3.1-5.3c-0.9-0.7-1.6-2-2.5-2.8c-1.1-1.1-2.2-2.2-3.2-3.3c0.6,0,1.1,0.3,1.7,0.5 c1.9,0.5,4,1,5.9,1.5c0.1-0.8,3.8-7.7,3.4-7.9c-1.2-0.7-2.7-1.5-3.7-2.3c1.2,0.3,2.6,0,3.8,0c-0.6-1.4-3.3-2.7-4.3-3.8 c1-0.3,2,0.2,3,0.3c0.7,0.1,1.4-0.1,2,0.2c0.3-2.1,0.3-4.1,0.4-6.2c0.1-1.3,0.5-3.7,0-4.9c-0.4-0.9-1.8-1.3-2.2-2.1 c0.6-0.3,1.2-0.2,1.8-0.1c0-0.5-0.4-7.3-0.8-7.2c-4.2,0.6-8,1.3-11.7,3.4c-0.7,0.4-1.5,0.6-1.7,1.3c-0.4,1.4,0.7,3.4,0.8,4.8 c-1.2-1.3-2.9-2.2-4.3-3.3c-1.5,1.4-2.9,2.5-4.1,4.3c-1,1.5-2.2,2.9-3.1,4.4c-0.3,0.6-1.1,1.5-1.3,2.1c-0.3,1.6,2.8,4.9,3.9,6.1 c-1.7-0.1-3.3-1.7-5.1-2c-1.9-0.3-1.9,1.8-3.1,2.4c0.7,0.1,1.6,1.3,2.1,1.9c-0.8-0.1-1.7-0.6-2.5-0.3c0.7,1.6,1.5,3.1,2.6,4.5 c-1.1,0-2.1-0.8-3.1-1c-0.5-0.1-1.1-0.1-1.5-0.2c-0.8,2-2.2,3.7-3.3,5.5C413,299.1,413,299.2,412.9,299.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M445.6,270.1c-2.3,2.2-3.6,6.2-4.9,9c-1.4,3.1-2.8,6.3-4.2,9.4c-2.7,5.8-5.5,11.4-9.2,16.7 c-7.4,10.7-14.1,22.2-23.1,31.7c-0.6,0.6-1.8-0.3-1.2-1c8.4-10.4,16.5-20.9,24.1-31.9c3.9-5.6,6.8-11.8,9.7-18 c2.6-5.5,5-11.4,8.2-16.5C445.3,269,446,269.6,445.6,270.1L445.6,270.1z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1852_",
    className: "st0",
    d: "M220.5,414.7c-27.1,15.6-71.1,15.5-98.3-0.2s-27.4-41.1-0.3-56.8 c27.1-15.6,71.1-15.5,98.3,0.2C247.4,373.6,247.5,399.1,220.5,414.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1851_",
    className: "st0",
    d: "M362.2,405.5c-6,3.5-15.7,3.4-21.7,0c-6-3.5-6-9.1-0.1-12.5c6-3.5,15.7-3.4,21.7,0 S368.1,402,362.2,405.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1850_",
    className: "st0",
    d: "M421.2,278c-2.6,1.5-6.9,1.5-9.5,0s-2.7-4,0-5.5c2.6-1.5,6.9-1.5,9.5,0 C423.8,274,423.8,276.5,421.2,278z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_587_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1832_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1834_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1836_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1849_",
    className: "st2",
    d: "M75.4,273.3c0,0,9.7,11.3,12.3,12.1c2.6,0.8,0.3,3.4-1.7,3.6s-8.3-0.1-10.1-1.9 c-1.8-1.8-7-3.7-7-3.7c0-5.9,1.4-9.6,1.4-9.6L75.4,273.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1848_",
    className: "st3",
    d: "M78.8,193.4c0,0,1.3,25,0.8,33.2s-2.5,49-2.5,49c-5.3,1.1-8.7,0-8.7,0 c-1.7-31.2-1.7-40.2-2.2-44.9s-1.1-18.1-1.1-18.1c-3.7-7.7,0.2-17.8,2-20.2C69,190,78.8,193.4,78.8,193.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1847_",
    className: "st2",
    d: "M59.6,284.1c0.3,4.6,2,10,2.4,12.7s-0.6,4.3-1.2,5.2c-0.6,0.9-8.4-1.7-9.4-4.7 c-1.1-3,1.1-5.6,1.3-11.2C55.1,281.7,59.6,284.1,59.6,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1846_",
    className: "st4",
    d: "M70.8,195.4c0,0-1.3,22.8-3.4,30.4c-2.1,7.6-4,29.8-4.9,33.7c-0.9,3.9-2,27.9-2,27.9 c-4.8,1.2-8.6,0-8.6,0c0.1-22.5-0.4-40.7,0-46.9s-0.2-24.4-0.2-24.4c-2-8.5-2.1-9.6,0-15.2C53.8,195.2,62.9,190.7,70.8,195.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1845_",
    className: "st5",
    d: "M75.2,141.3c7.9,2.2,12.1,22,14.3,26.4c2.2,4.4,20.6,5.5,20.6,5.5c1.1,3.9-2,7.9-2,7.9 c-17.7-0.7-23.9-2.2-27.2-9.2C77.5,165,66,143.7,75.2,141.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1844_",
    className: "st5",
    d: "M75.2,141.3c-7-0.3-23.2,3.3-28.5,10.1s2.4,18.8,4.3,26.1c1.9,7.2-0.9,25.4-0.9,27.2 c8.3,5.5,28.2,6.2,30.4-2c0.9-8.9-1.1-19.5-1.2-24.7C79.5,166.8,84.4,144.6,75.2,141.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1843_",
    className: "st6",
    d: "M69.2,143c4.5,15.8,5.6,33.5,5.1,40.2c-0.4,6.7-0.6,28.4-0.6,28.4 c5.2-2.8,7.5-7.8,7.5-10.1s-2-21.9-1.9-23.5s2.6-19.6,1.9-27.7c-0.7-8.1-6-9-6-9h-6.7L69.2,143z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1842_",
    className: "st7",
    d: "M73.5,123.9c3.1,1,0,8,0,8V123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1841_",
    className: "st8",
    d: "M73.7,124.8c0,0,1.2,4.1,0.7,7.3c-0.4,3.2-0.7,9.5-3.5,11.5s-6.9-0.3-9.5-2.6 c-2.7-2.3-5.5-6.5-5.6-11.5c-0.1-5.1,1.9-11.3,9.2-11C72.3,118.9,73.7,124.8,73.7,124.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1840_",
    className: "st8",
    d: "M59.5,136.5c0,0,0.6,6.5-1.1,8.9c-0.1,1.6,4.5,8.4,9.1,7.2c2.7-0.7,2.3-3.8,2.3-3.8 c-0.3-2.4,0-8.1,0-8.1L59.5,136.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1839_",
    className: "st7",
    d: "M75.4,119.4c1,3.8-0.1,5.1-3.3,6.2c-3.2,1.1-11.6-1.4-11.6-1.4c0.6,4-0.7,6.1-0.7,6.1 c-1.4-4-2.7-1.9-2.8,1.2c-0.1,3.2,1.6,3.1,1.6,3.1c-0.1,2.7-1,3.6-1,3.6c-3.4-2.3-8-18-1.9-18.4 C55.9,114.3,73.2,111.3,75.4,119.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1838_",
    className: "st6",
    d: "M58,144.4c5.4,11.5,8.3,21.9,8.1,31.4c-0.2,9.5-2.1,37-2.1,37c-9.4-2.3-15.9-5-17.7-8.2 c4-10.6,5.5-17.8,4.7-20.8s-8-26.1-4.3-33C50.2,147,58,144.4,58,144.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1837_",
    className: "st5",
    d: "M49.8,150.6c6.5,3.2,11.7,21.2,16.6,26c2.8,2.7,16.7,6.3,20.5,6.4 c1.5,3.4-1.2,7.2-1.2,7.2c-23.7-2.2-24.7-3.5-32-12.8C44.7,165.8,41.1,148.4,49.8,150.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M69.6,144.2c-2,0.8-4.9-0.4-8.6-3.4c0,0,1.1,4.4,8.6,6V144.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1835_",
    className: "st6",
    d: "M59.2,142.9c0,0.2-1.2,1.5-1.2,1.5s2.4,5.2,3.2,7.4c0.9,2.3,3.1,4.2,3.1,4.2l3.1-3.3 C63.2,150.5,59.2,142.9,59.2,142.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1833_",
    className: "st6",
    d: "M69.3,144.6c-0.3-0.3-0.9,6.4-2,8.2c2,1.8,3.1,2.3,3.1,2.3S71.7,147.5,69.3,144.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1803_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1822_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1825_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1826_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1831_",
    className: "st10",
    d: "M277.2,214.9c-0.2,3.4-0.6,6.8-0.6,6.8h-0.8c0,0,0-5.1-0.8-4 C275.2,214.9,277.2,214.9,277.2,214.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1830_",
    className: "st8",
    d: "M266.8,220.7c-0.4,0-0.9-0.4-1.3-1c0.8-0.9,1.5-1.8,2-2.5c1.6-2.3,4.3-7.3,4.4-9.5 c0.1-2.3-1.3-25.8-1.6-28.7c-0.4-2.9-1.5-13.8-1.4-14.4c0.1-0.6,10.1,3.9,10.1,3.9c-0.1,0.9-1.5,6.5-0.9,10.2 c0.6,3.6,1.4,6,0.9,12c-0.5,5.9-3.4,15.5-2.4,20c0,0.1,0,0.2,0,0.2C273.8,214.8,272.7,222.7,266.8,220.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1829_",
    className: "st10",
    d: "M265.5,219.7c0.4,0.6,0.9,1,1.3,1c6,2,7-5.9,10-9.9c0.9,4.3,0.5,4.8-0.3,5.4 c-0.8,0.6-3.6,4-4.1,6.4s-8,2.1-9.4,1.6C262.1,223.9,263.8,221.7,265.5,219.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1828_",
    className: "st8",
    d: "M287.5,188.7c0.3,2.6,1.8,23,1.6,26.4c-0.2,2.1-1.1,5.3-1.7,7.9 c-0.4,1.7-0.6,3.1-0.4,3.7c0.6,1.7,0.6,6.9,3.4,5.7s4.7-4.8,4.1-8.8s0.1-5.9-0.1-8.3c-0.2-2.4,1.4-17.2,1.7-22.4 c0.3-5.3-1.5-7.8-1.6-11.3s0.9-10.8,0.9-10.8s-12.1-6.3-11.1,1.3C285.3,179.8,287.2,186.1,287.5,188.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1827_",
    className: "st10",
    d: "M286.5,226.9c0.2,3.5,1.1,6.7,3.9,5.6c2.8-1.2,4.7-4.8,4.1-8.8 c-1.5,4.4-7.3,4.2-7.1-0.7C287,224.6,286.4,226.2,286.5,226.9z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1824_",
    className: "st11",
    d: "M268.1,139.3c0,0,0,24.5,0,32.5s2.1,35.1,2.1,35.1c4.1,1.6,8.1-0.4,8.1-0.4 c0.6-7,2.6-18.5,3-24.6s-2.4-7.1-1.3-11.5s4.3-28.1,4.3-28.1L268.1,139.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1823_",
    className: "st11",
    d: "M281.3,144.5c0,0,2.1,26.3,3,29.6s1.5,16.2,2.2,20.6c0.7,4.4,0.7,17.2,0.7,17.2 c1.6,5.2,8.2,0.8,8.2,0.8c2.7-16.3,0.8-24.4,0.8-29.2c-0.1-4.8,2.3-17.3,1.8-22.5s-1-16,0-18s2.1-5.3,2.5-11.3 c-7.8-3-20,0.4-20,0.4L281.3,144.5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1821_",
    className: "st5",
    d: "M269.3,87.2c6.9-0.3,18.6,7.8,23.9,14.5s2,13.9,0.2,21.1c-1.8,7.2,1,25.1,1,26.8 c-8.1,5.5-23.4,6.1-25.6-1.9c-1-8.8,1-17.9,1.1-23.1C269.6,113.5,260.2,90.5,269.3,87.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1820_",
    className: "st6",
    d: "M275.3,88.8c-3.6,15.6-2.5,32.4-1.7,39c0.8,6.6,0.9,28.6,0.9,28.6c-5.3-2.7-7.9-7.7-8-9.9 c-0.1-2.3,1.9-21.3,1.8-22.9s-2.9-16.3-2.6-24.2c0.3-8,3.3-9.2,3.3-9.2l6.8-3L275.3,88.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1819_",
    className: "st5",
    d: "M285.3,90.4c-5.3,11.3-2.7,21.7-2.5,31.1c0.2,9.3,5.1,35.5,5.1,35.5 c9.3-2.3,10.4-8.5,12.2-11.7c4.3-21.8-1.1-39.5-5.2-46.1C291.7,94.1,285.3,90.4,285.3,90.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1816_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1817_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1818_",
    className: "st12",
    d: "M247.9,125.7c1.3,0.7,3.4,0.7,4.7,0s1.3-2,0-2.7s-3.4-0.7-4.7,0 C246.6,123.8,246.6,125,247.9,125.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1814_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1815_",
    className: "st6",
    d: "M291.2,99.4c-6.4,3.2-7,22.1-12,26.8c-2.8,2.7-13.9,0.5-17.8,0.6 c-1.5,3.3,0.5,7.4,0.5,7.4c21.3,1,23.8,1.7,29.2-8.6C295.4,117.5,299.8,97.2,291.2,99.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1811_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1813_",
    className: "st6",
    d: "M269.1,90.2c-4.1,2.2-6.1,19.4-11,23.7c-2.8,2.4-4,4.7-9.7,7.5c-1.5,3.1,2.6,5,2.6,5 c11.3-4.3,13.9-8,17.7-13.7C273.4,105.6,277.7,88.2,269.1,90.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1812_",
    className: "st8",
    d: "M250.8,125.8c-0.1,0.4-1.2,1.6-2.2,2.7c-1,1.1-2.5,3-3,2.6c-0.5-0.5,0.4-2.4,0.4-2.4 s-2.9,2.8-3.4,3.7s-0.2-1.8,0.5-3c-1.9,2.8-2.3,3.5-2.5,2.8s1.4-4.5,1.2-4.2c-2.2,3.2-3,3.7-2.7,2.2c0.2-1.5,2.3-4,3.6-4.7 c-3.7,2.4-4,2.2-3.1,1.1s4.4-3.7,9-4.4C251.5,124.9,250.8,125.8,250.8,125.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1810_",
    className: "st8",
    d: "M248.3,131.7c1.2-1.9,3-4,5.2-4.6c1.6-0.4,3.2-0.1,4.7,0.4c1.2,0.4,3,0.6,4.2,1.1 c0.6,1.4,0.9,2.7,0.9,4c-0.2,0.1-0.5,0.1-0.8,0.2c-1.3,0.1-2.6,0.6-3.9,0.6c-0.9,0-2.3,0.2-3,0c0.3,0.1,0.7,0.3,0.8,0.6 c0,0.3-0.2,0.5-0.5,0.6c-1.9,0.5-3.6-1.8-4.7-2.9C251.1,131.7,246.7,134.1,248.3,131.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1809_",
    className: "st13",
    d: "M268.2,71.3c-0.1,0.2-0.2,0.4-0.3,0.6c-0.3,1-0.1,2.3-0.4,3.3c-0.4,1.7-1.6,3-2.2,4.7 c-2.1,6,3.9,9.4,9.1,9c0.9-0.1,1.9-0.3,2.6-0.9c2.5-1.9-0.3-5-1.5-6.8c-0.8-1.2-2-2.9-2.1-4.5c-0.1-1.4,0.7-2.7,0.4-4.2 C273.4,69.5,269.6,68.8,268.2,71.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1808_",
    className: "st8",
    d: "M283.7,83.5c0,0-1.7,5.9,2.2,8.4c0.1,1.4-4,7.6-8.1,6.5c-2.4-0.6-3.6-4-3.6-4 c0.2-2.1,1.5-6.6,1.5-6.6L283.7,83.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1806_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1807_",
    className: "st8",
    d: "M269.9,71.5c0,0-1.1,3.8-0.7,6.7c0.4,2.9,0.7,8.7,3.2,10.6c2.6,1.9,6.3-0.3,8.7-2.4 c2.5-2.1,5.1-5.9,5.1-10.6c0.1-4.6-1.8-10.3-8.5-10C271.1,66,269.9,71.5,269.9,71.5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1805_",
    className: "st13",
    d: "M274.6,68.6c-1.7,2.1-0.9,4.7,1.2,6.3c1.5,1.1,2.8,1.8,3.8,3.4c0.9,1.5,1.4,3.3,1.5,5.1 c0.1,1.5,0.1,2.9,0.2,4.4c0,0.7,0.1,1.6,0.8,1.8c0.9,0.2,2.6-0.4,3.3-0.9c1.2-0.7,2.3-1.7,3.2-2.8c1.8-2.1,2.9-4.8,3-7.6 c0.2-5.2-2.8-8.5-6.5-11.6C281.2,63.8,277.6,64.9,274.6,68.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1804_",
    className: "st13",
    d: "M272.3,66L272.3,66c1.3-0.9,6.7-2.6,6.7,0.2c0,2.7-4,5.4-6.1,6.6c-0.9,0.5-1.9,1-2.7,1.6 c-1.1,0.9-1.2,2.5-2.2,3.2c-1.5-1.4-1.1-4.9-0.5-6.6C268.3,68.7,270.3,67.3,272.3,66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M275.3,89.4c2.7-0.2,5.7-2.9,5.7-2.9s-0.6,3.2-6.1,4.3L275.3,89.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1802_",
    className: "st5",
    d: "M353.2,249.3c-2.6,4.1-2,7-1.3,7.4c15.7,7,25.5,4.9,27.9,4.1c-2.6-3.6-5.1-7.1-8-11.1 C364.1,251.1,353.2,249.3,353.2,249.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1752_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1800_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1801_",
    className: "st15",
    points: "307.7,137.6 307.6,154.9 276.2,173.2 276.2,155.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1798_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1799_",
    className: "st15",
    points: "166.3,155.9 166.2,173.2 134.6,154.9 134.6,137.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1796_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1797_",
    className: "st16",
    d: "M247.9,179.9v-17.3c0-2.4,1.6-4.9,4.8-6.7c6.4-3.7,17-3.7,23.4,0v17.3 c-6.5-3.7-17-3.7-23.4,0C249.5,175.1,247.9,177.5,247.9,179.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1794_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1795_",
    className: "st16",
    d: "M194.6,162.7V180c0-2.5-1.6-5-4.9-6.8c-6.5-3.8-17-3.7-23.5,0v-17.3 c6.5-3.8,17-3.8,23.5,0C193,157.8,194.6,160.3,194.6,162.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1792_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1793_",
    className: "st15",
    points: "221.4,187.7 221.4,205 189.8,186.8 189.8,169.5  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1790_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1791_",
    className: "st15",
    points: "252.8,169.5 252.8,186.8 221.4,205 221.4,187.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1788_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1789_",
    className: "st17",
    d: "M307.7,137.6l-31.4,18.3c-6.5-3.7-17-3.7-23.4,0c-6.5,3.8-6.4,9.8,0.1,13.6l-31.4,18.3 L190,169.5c6.5-3.8,6.4-9.8-0.1-13.6s-17-3.7-23.5,0l-31.6-18.3L221,87.5L307.7,137.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1786_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1787_",
    className: "st18",
    d: "M168.5,177.9v17.3c0,2.4-1.6,4.9-4.8,6.7v-17.3C166.9,182.8,168.5,180.4,168.5,177.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1784_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1785_",
    className: "st18",
    points: "195.3,202.9 195.2,220.2 163.8,238.5 163.8,221.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1782_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1783_",
    className: "st11",
    d: "M135.5,245.3V228c0-2.4,1.6-4.9,4.8-6.7c6.5-3.8,17-3.8,23.5,0v17.3 c-6.5-3.7-17-3.7-23.5,0C137.1,240.4,135.5,242.8,135.5,245.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1780_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1781_",
    className: "st18",
    points: "140.5,234.8 140.4,252.1 109,270.4 109,253  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1778_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1779_",
    className: "st6",
    points: "109,253 109,270.4 22.2,220.2 22.3,202.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1776_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1777_",
    className: "st19",
    d: "M163.6,171.1c6.5,3.8,6.5,9.8,0.1,13.6l31.6,18.3l-31.4,18.3c-6.5-3.7-17-3.7-23.5,0 c-6.5,3.8-6.4,9.8,0.1,13.6L109,253l-86.8-50.1l86.2-50.1l31.6,18.3C146.6,167.3,157.1,167.3,163.6,171.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1774_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1775_",
    className: "st6",
    d: "M274.2,195.1v-17.3c0,2.5,1.6,4.9,4.9,6.8v17.3C275.9,200.1,274.2,197.6,274.2,195.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1772_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1773_",
    className: "st6",
    points: "279.4,221.2 279.3,238.5 247.7,220.2 247.7,202.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1770_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1771_",
    className: "st11",
    d: "M307.7,228v17.3c0-2.5-1.6-5-4.9-6.8c-6.5-3.8-17-3.8-23.5,0v-17.3 c6.5-3.8,17-3.8,23.5,0C306.1,223.1,307.7,225.6,307.7,228z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1768_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1769_",
    className: "st6",
    points: "334.5,253 334.5,270.4 302.9,252.1 302.9,234.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1766_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1767_",
    className: "st20",
    points: "420.8,202.9 420.7,220.2 334.5,270.4 334.5,253  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1764_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1765_",
    className: "st19",
    d: "M420.8,202.9L334.5,253l-31.6-18.3c6.5-3.8,6.4-9.8-0.1-13.6s-17-3.8-23.5,0l-31.6-18.3 l31.4-18.3c-6.5-3.8-6.5-9.8-0.1-13.6c6.4-3.7,16.9-3.8,23.4,0l31.4-18.3L420.8,202.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1762_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1763_",
    className: "st15",
    d: "M281.6,243.2v17.3c0,2.4-1.6,4.9-4.8,6.7v-17.3C280,248.1,281.6,245.7,281.6,243.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1760_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1761_",
    className: "st21",
    d: "M161.9,260.5v-17.3c0,2.5,1.6,4.9,4.9,6.8v17.3C163.5,265.4,161.8,262.9,161.9,260.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1757_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1759_",
    className: "st22",
    d: "M191.2,324.4c0,0,0.8,0.3,2.8,1.1c2,0.8,6.3,1.1,9,0.7s6.4-1,5.7-2s-14.2-4.4-14.8-4.1 C193.4,320.4,191.2,324.4,191.2,324.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1758_",
    className: "st15",
    points: "222.2,318.4 222.1,335.7 135.3,285.6 135.4,268.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1755_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1756_",
    className: "st16",
    points: "308.4,268.2 308.3,285.6 222.1,335.7 222.2,318.4  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1753_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1754_",
    className: "st17",
    d: "M276.7,236.4c6.5,3.7,6.5,9.8,0.1,13.6l31.6,18.3l-86.2,50.1l-86.8-50.1l31.4-18.3 c-6.5-3.8-6.5-9.8-0.1-13.6c6.5-3.8,17-3.8,23.5,0l31.4-18.3l31.6,18.3C259.7,232.6,270.2,232.6,276.7,236.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1114_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1737_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1747_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1750_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1751_",
    className: "st11",
    d: "M222.4,264.6v1.8c0,1.4-0.9,2.8-2.8,3.9c-3.8,2.2-9.9,2.2-13.7,0 c-1.9-1.1-2.9-2.5-2.8-4v-1.8c0,1.4,0.9,2.9,2.8,4c3.8,2.2,9.9,2.2,13.7,0C221.4,267.4,222.3,266,222.4,264.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1748_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1749_",
    className: "st18",
    d: "M219.5,260.6c3.8,2.2,3.8,5.7,0.1,7.9c-3.8,2.2-9.9,2.2-13.7,0s-3.8-5.7,0-7.9 C209.6,258.4,215.7,258.4,219.5,260.6z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1746_",
    className: "st11",
    d: "M235.5,206c-0.6-0.3-1.4-0.3-2.2,0.2L185.1,234c-1.7,1-3.1,3.4-3.1,5.4l0.1,36 c0,1,0.4,1.7,0.9,2l3.1,1.8c-0.6-0.3-0.9-1-0.9-2l-0.1-36c0-2,1.4-4.4,3.1-5.4l48.2-27.8c0.9-0.5,1.7-0.5,2.2-0.2L235.5,206z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1745_",
    className: "st18",
    d: "M236.4,208c1.7-1,3.1-0.2,3.1,1.8l0.1,36c0,2-1.4,4.4-3.1,5.4L188.3,279 c-1.7,1-3.1,0.2-3.1-1.8l-0.1-36c0-2,1.4-4.4,3.1-5.4L236.4,208z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1744_",
    className: "st23",
    x1: 187.3,
    y1: 241.2,
    x2: 187.3,
    y2: 241.2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1743_",
    className: "st24",
    points: "237.3,217 237.3,210 235.9,210.8 233,212.5 194.3,234.9 187.3,238.9  187.3,241.2 187.3,241.3 187.3,258.3 187.3,272.6 218,254.9 222.8,252.1 237.4,243.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1742_",
    className: "st19",
    points: "194.3,234.9 187.3,238.9 187.3,241.1 237.3,212.2 237.3,210  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1741_",
    className: "st11",
    d: "M193.2,243.8c0,1-0.7,2.2-1.6,2.7c-0.9,0.5-1.6,0.1-1.6-0.9s0.7-2.2,1.6-2.7 C192.5,242.4,193.2,242.8,193.2,243.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1740_",
    className: "st15",
    d: "M193.2,249.4c0,1-0.7,2.2-1.6,2.7c-0.9,0.5-1.6,0.1-1.6-0.9s0.7-2.2,1.6-2.7 S193.2,248.4,193.2,249.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1739_",
    className: "st6",
    d: "M193.2,254.9c0,1-0.7,2.2-1.6,2.7c-0.9,0.5-1.6,0.1-1.6-0.9s0.7-2.2,1.6-2.7 C192.5,253.5,193.2,253.9,193.2,254.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1738_",
    className: "st25",
    d: "M193,273.2c0,0.7-0.5,1.6-1.1,2s-1.1,0.1-1.1-0.7c0-0.7,0.5-1.6,1.1-2 C192.4,272.2,193,272.4,193,273.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1732_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1735_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1736_",
    className: "st18",
    points: "257,274.6 241.6,265.7 262.1,253.8 277.5,262.7  "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1734_",
    className: "st11",
    points: "257,275.2 257,274.6 277.5,262.7 277.5,263.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1733_",
    className: "st11",
    points: "257,274.6 257,275.2 241.6,266.3 241.6,265.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1159_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1731_",
    className: "st18",
    points: "202,285.4 202,286.7 217,295.4 217,294.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1730_",
    className: "st11",
    points: "217,294.1 217,295.4 250.4,276.2 250.4,274.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1729_",
    className: "st5",
    points: "202,285.4 217,294.1 250.4,274.9 235.3,266.1  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1160_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1727_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1728_",
    className: "st26",
    points: "233.3,268.3 233.3,269 235.3,270.2 235.3,269.5  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1725_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1726_",
    className: "st27",
    points: "235.3,269.5 235.3,270.2 237.4,269 237.4,268.4  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1723_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1724_",
    className: "st0",
    points: "233.3,268.3 235.3,269.5 237.4,268.4 235.3,267.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1721_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1722_",
    className: "st26",
    points: "230.6,269.8 230.6,270.5 232.7,271.7 232.7,271.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1719_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1720_",
    className: "st27",
    points: "232.7,271.1 232.7,271.7 234.8,270.5 234.8,269.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1717_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1718_",
    className: "st0",
    points: "230.6,269.8 232.7,271.1 234.8,269.9 232.7,268.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1715_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1716_",
    className: "st26",
    points: "228,271.4 228,272 230.1,273.2 230.1,272.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1713_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1714_",
    className: "st27",
    points: "230.1,272.6 230.1,273.2 232.1,272.1 232.1,271.4  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1711_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1712_",
    className: "st0",
    points: "228,271.4 230.1,272.6 232.1,271.4 230,270.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1709_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1710_",
    className: "st26",
    points: "225.4,272.9 225.4,273.5 227.4,274.8 227.4,274.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1707_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1708_",
    className: "st27",
    points: "227.4,274.1 227.4,274.8 229.5,273.6 229.5,272.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1705_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1706_",
    className: "st0",
    points: "225.4,272.9 227.4,274.1 229.5,272.9 227.4,271.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1703_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1704_",
    className: "st26",
    points: "222.7,274.4 222.7,275.1 224.8,276.3 224.8,275.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1701_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1702_",
    className: "st27",
    points: "224.8,275.6 224.8,276.3 226.9,275.1 226.9,274.4  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1699_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1700_",
    className: "st0",
    points: "222.7,274.4 224.8,275.6 226.9,274.4 224.8,273.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1696_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1697_",
    className: "st26",
    points: "220.1,275.9 220.1,276.6 222.2,277.8 222.2,277.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1694_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1695_",
    className: "st27",
    points: "222.2,277.1 222.2,277.8 224.2,276.6 224.2,276  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1692_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1693_",
    className: "st0",
    points: "220.1,275.9 222.2,277.1 224.2,276 222.1,274.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1690_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1691_",
    className: "st26",
    points: "217.5,277.4 217.5,278.1 219.5,279.3 219.5,278.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1688_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1689_",
    className: "st27",
    points: "219.5,278.7 219.5,279.3 221.6,278.1 221.6,277.5  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1686_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1687_",
    className: "st0",
    points: "217.5,277.4 219.5,278.7 221.6,277.5 219.5,276.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1684_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1685_",
    className: "st26",
    points: "214.8,279 214.8,279.6 216.9,280.8 216.9,280.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1682_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1683_",
    className: "st27",
    points: "216.9,280.2 216.9,280.8 219,279.7 219,279  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1680_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1681_",
    className: "st0",
    points: "214.8,279 216.9,280.2 219,279 216.9,277.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1678_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1679_",
    className: "st26",
    points: "212.2,280.5 212.2,281.2 214.3,282.4 214.3,281.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1676_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1677_",
    className: "st27",
    points: "214.3,281.7 214.3,282.4 216.3,281.2 216.3,280.5  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1674_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1675_",
    className: "st0",
    points: "212.2,280.5 214.3,281.7 216.3,280.5 214.2,279.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1672_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1673_",
    className: "st26",
    points: "209.6,282 209.6,282.7 211.6,283.9 211.6,283.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1670_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1671_",
    className: "st27",
    points: "211.6,283.2 211.6,283.9 213.7,282.7 213.7,282  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1668_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1669_",
    className: "st0",
    points: "209.6,282 211.6,283.2 213.7,282 211.6,280.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1666_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1667_",
    className: "st26",
    points: "204.3,285 204.3,285.7 206.4,286.9 206.4,286.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1664_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1665_",
    className: "st27",
    points: "206.4,286.3 206.4,286.9 211.1,284.2 211.1,283.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1662_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1663_",
    className: "st0",
    points: "204.3,285 206.4,286.3 211.1,283.6 209,282.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1660_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1661_",
    className: "st26",
    points: "233.3,271.4 233.3,272.1 235.4,273.3 235.4,272.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1658_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1659_",
    className: "st27",
    points: "235.4,272.6 235.4,273.3 240.1,270.6 240.1,269.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1656_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1657_",
    className: "st0",
    points: "233.3,271.4 235.4,272.6 240.1,269.9 238,268.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1654_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1655_",
    className: "st26",
    points: "230.6,272.9 230.6,273.6 232.7,274.8 232.7,274.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1652_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1653_",
    className: "st27",
    points: "232.7,274.1 232.7,274.8 234.8,273.6 234.8,272.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1650_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1651_",
    className: "st0",
    points: "230.6,272.9 232.7,274.1 234.8,272.9 232.7,271.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1646_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1647_",
    className: "st26",
    points: "228,274.4 228,275.1 230.1,276.3 230.1,275.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1643_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1645_",
    className: "st27",
    points: "230.1,275.6 230.1,276.3 232.2,275.1 232.2,274.5  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1641_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1642_",
    className: "st0",
    points: "228,274.4 230.1,275.6 232.2,274.5 230.1,273.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1637_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1639_",
    className: "st26",
    points: "225.4,276 225.4,276.6 227.5,277.8 227.5,277.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1625_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1626_",
    className: "st27",
    points: "227.5,277.2 227.5,277.8 229.5,276.6 229.5,276  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1623_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1624_",
    className: "st0",
    points: "225.4,276 227.5,277.2 229.5,276 227.4,274.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1621_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1622_",
    className: "st26",
    points: "222.7,277.5 222.7,278.1 224.8,279.3 224.8,278.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1619_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1620_",
    className: "st27",
    points: "224.8,278.7 224.8,279.3 226.9,278.2 226.9,277.5  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1617_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1618_",
    className: "st0",
    points: "222.7,277.5 224.8,278.7 226.9,277.5 224.8,276.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1615_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1616_",
    className: "st26",
    points: "220.1,279 220.1,279.7 222.2,280.9 222.2,280.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1613_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1614_",
    className: "st27",
    points: "222.2,280.2 222.2,280.9 224.3,279.7 224.3,279  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1611_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1612_",
    className: "st0",
    points: "220.1,279 222.2,280.2 224.3,279 222.2,277.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1609_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1610_",
    className: "st26",
    points: "217.5,280.5 217.5,281.2 219.6,282.4 219.6,281.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1607_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1608_",
    className: "st27",
    points: "219.6,281.7 219.6,282.4 221.6,281.2 221.6,280.5  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1605_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1606_",
    className: "st0",
    points: "217.5,280.5 219.6,281.7 221.6,280.5 219.5,279.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1603_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1604_",
    className: "st26",
    points: "214.8,282 214.8,282.7 216.9,283.9 216.9,283.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1601_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1602_",
    className: "st27",
    points: "216.9,283.2 216.9,283.9 219,282.7 219,282.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1599_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1600_",
    className: "st0",
    points: "214.8,282 216.9,283.2 219,282.1 216.9,280.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1597_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1598_",
    className: "st26",
    points: "212.2,283.6 212.2,284.2 214.3,285.4 214.3,284.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1595_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1596_",
    className: "st27",
    points: "214.3,284.8 214.3,285.4 216.4,284.2 216.4,283.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1593_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1594_",
    className: "st0",
    points: "212.2,283.6 214.3,284.8 216.4,283.6 214.3,282.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1590_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1592_",
    className: "st26",
    points: "209.6,285.1 209.6,285.7 211.7,286.9 211.7,286.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1588_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1589_",
    className: "st27",
    points: "211.7,286.3 211.7,286.9 213.7,285.8 213.7,285.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1572_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1573_",
    className: "st0",
    points: "209.6,285.1 211.7,286.3 213.7,285.1 211.6,283.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1568_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1570_",
    className: "st26",
    points: "206.9,286.6 207,287.3 209,288.5 209,287.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1562_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1564_",
    className: "st27",
    points: "209,287.8 209,288.5 211.1,287.3 211.1,286.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1559_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1560_",
    className: "st0",
    points: "206.9,286.6 209,287.8 211.1,286.6 209,285.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1557_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1558_",
    className: "st26",
    points: "235.9,272.9 235.9,273.6 238,274.8 238,274.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1555_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1556_",
    className: "st27",
    points: "238,274.1 238,274.8 242.7,272.1 242.7,271.4  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1553_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1554_",
    className: "st0",
    points: "235.9,272.9 238,274.1 242.7,271.4 240.6,270.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1551_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1552_",
    className: "st26",
    points: "233.3,274.5 233.3,275.1 235.4,276.3 235.4,275.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1533_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1534_",
    className: "st27",
    points: "235.4,275.7 235.4,276.3 237.4,275.1 237.4,274.5  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1531_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1532_",
    className: "st0",
    points: "233.3,274.5 235.4,275.7 237.4,274.5 235.4,273.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1528_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1530_",
    className: "st26",
    points: "230.7,276 230.7,276.6 232.8,277.8 232.8,277.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1525_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1526_",
    className: "st27",
    points: "232.8,277.2 232.8,277.8 234.8,276.7 234.8,276  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1523_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1524_",
    className: "st0",
    points: "230.7,276 232.8,277.2 234.8,276 232.7,274.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1518_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1521_",
    className: "st26",
    points: "228,277.5 228,278.2 230.1,279.4 230.1,278.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1481_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1516_",
    className: "st27",
    points: "230.1,278.7 230.1,279.4 232.2,278.2 232.2,277.5  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1478_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1480_",
    className: "st0",
    points: "228,277.5 230.1,278.7 232.2,277.5 230.1,276.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1476_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1477_",
    className: "st26",
    points: "225.4,279 225.4,279.7 227.5,280.9 227.5,280.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1474_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1475_",
    className: "st27",
    points: "227.5,280.2 227.5,280.9 229.5,279.7 229.5,279  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1439_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1471_",
    className: "st0",
    points: "225.4,279 227.5,280.2 229.5,279 227.5,277.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1359_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1363_",
    className: "st26",
    points: "222.8,280.5 222.8,281.2 224.9,282.4 224.9,281.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1357_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1358_",
    className: "st27",
    points: "224.9,281.7 224.9,282.4 226.9,281.2 226.9,280.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1282_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1303_",
    className: "st0",
    points: "222.8,280.5 224.9,281.7 226.9,280.6 224.8,279.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1280_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1281_",
    className: "st26",
    points: "220.1,282.1 220.1,282.7 222.2,283.9 222.2,283.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1278_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1279_",
    className: "st27",
    points: "222.2,283.3 222.2,283.9 224.3,282.7 224.3,282.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1276_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1277_",
    className: "st0",
    points: "220.1,282.1 222.2,283.3 224.3,282.1 222.2,280.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1274_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1275_",
    className: "st26",
    points: "217.5,283.6 217.5,284.2 219.6,285.4 219.6,284.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1272_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1273_",
    className: "st27",
    points: "219.6,284.8 219.6,285.4 221.6,284.3 221.6,283.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1269_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1271_",
    className: "st0",
    points: "217.5,283.6 219.6,284.8 221.6,283.6 219.6,282.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1267_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1268_",
    className: "st26",
    points: "214.9,285.1 214.9,285.8 217,287 217,286.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1265_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1266_",
    className: "st27",
    points: "217,286.3 217,287 219,285.8 219,285.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1263_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1264_",
    className: "st0",
    points: "214.9,285.1 217,286.3 219,285.1 216.9,283.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1261_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1262_",
    className: "st26",
    points: "209.6,288.1 209.6,288.8 211.7,290 211.7,289.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1259_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1260_",
    className: "st27",
    points: "211.7,289.3 211.7,290 216.4,287.3 216.4,286.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1257_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1258_",
    className: "st0",
    points: "209.6,288.1 211.7,289.3 216.4,286.6 214.3,285.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1255_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1256_",
    className: "st26",
    points: "236,276 236,276.7 238,277.9 238,277.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1253_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1254_",
    className: "st27",
    points: "238,277.2 238,277.9 245.4,273.6 245.4,273  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1251_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1252_",
    className: "st0",
    points: "236,276 238,277.2 245.4,273 243.3,271.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1249_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1250_",
    className: "st26",
    points: "233.3,277.5 233.3,278.2 235.4,279.4 235.4,278.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1247_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1248_",
    className: "st27",
    points: "235.4,278.7 235.4,279.4 237.5,278.2 237.5,277.5  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1245_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1246_",
    className: "st0",
    points: "233.3,277.5 235.4,278.7 237.5,277.5 235.4,276.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1243_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1244_",
    className: "st26",
    points: "230.7,279 230.7,279.7 232.8,280.9 232.8,280.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1241_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1242_",
    className: "st27",
    points: "232.8,280.3 232.8,280.9 234.8,279.7 234.8,279.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1239_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1240_",
    className: "st0",
    points: "230.7,279 232.8,280.3 234.8,279.1 232.7,277.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1237_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1238_",
    className: "st26",
    points: "228.1,280.6 228.1,281.2 230.1,282.4 230.1,281.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1235_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1236_",
    className: "st27",
    points: "230.1,281.8 230.1,282.4 232.2,281.2 232.2,280.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1233_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1234_",
    className: "st0",
    points: "228.1,280.6 230.1,281.8 232.2,280.6 230.1,279.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1231_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1232_",
    className: "st26",
    points: "225.4,282.1 225.4,282.7 227.5,284 227.5,283.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1229_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1230_",
    className: "st27",
    points: "227.5,283.3 227.5,284 229.6,282.8 229.6,282.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1227_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1228_",
    className: "st0",
    points: "225.4,282.1 227.5,283.3 229.6,282.1 227.5,280.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1225_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1226_",
    className: "st26",
    points: "222.8,283.6 222.8,284.3 224.9,285.5 224.9,284.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1223_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1224_",
    className: "st27",
    points: "224.9,284.8 224.9,285.5 226.9,284.3 226.9,283.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1221_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1222_",
    className: "st0",
    points: "222.8,283.6 224.9,284.8 226.9,283.6 224.9,282.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1219_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1220_",
    className: "st26",
    points: "220.2,285.1 220.2,285.8 222.2,287 222.2,286.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1217_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1218_",
    className: "st27",
    points: "222.2,286.3 222.2,287 224.3,285.8 224.3,285.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1215_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1216_",
    className: "st0",
    points: "220.2,285.1 222.2,286.3 224.3,285.1 222.2,283.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1213_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1214_",
    className: "st26",
    points: "217.5,286.6 217.5,287.3 219.6,288.5 219.6,287.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1211_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1212_",
    className: "st27",
    points: "219.6,287.9 219.6,288.5 221.7,287.3 221.7,286.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1209_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1210_",
    className: "st0",
    points: "217.5,286.6 219.6,287.9 221.7,286.7 219.6,285.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1207_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1208_",
    className: "st26",
    points: "212.3,289.7 212.3,290.3 214.3,291.6 214.3,290.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1205_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1206_",
    className: "st27",
    points: "214.3,290.9 214.3,291.6 219,288.8 219,288.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1203_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1204_",
    className: "st0",
    points: "212.3,289.7 214.3,290.9 219,288.2 217,287  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1201_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1202_",
    className: "st26",
    points: "243.9,274.5 243.9,275.2 246,276.4 246,275.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1199_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1200_",
    className: "st27",
    points: "246,275.7 246,276.4 248,275.2 248,274.5  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1197_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1198_",
    className: "st0",
    points: "243.9,274.5 246,275.7 248,274.5 245.9,273.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1195_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1196_",
    className: "st26",
    points: "241.2,276 241.3,276.7 243.3,277.9 243.3,277.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1193_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1194_",
    className: "st27",
    points: "243.3,277.2 243.3,277.9 245.4,276.7 245.4,276  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1191_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1192_",
    className: "st0",
    points: "241.2,276 243.3,277.2 245.4,276 243.3,274.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1189_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1190_",
    className: "st26",
    points: "238.6,277.5 238.6,278.2 240.7,279.4 240.7,278.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1187_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1188_",
    className: "st27",
    points: "240.7,278.8 240.7,279.4 242.8,278.2 242.8,277.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1185_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1186_",
    className: "st0",
    points: "238.6,277.5 240.7,278.8 242.8,277.6 240.7,276.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1183_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1184_",
    className: "st26",
    points: "225.5,285.1 225.5,285.8 227.5,287 227.5,286.4  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1181_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1182_",
    className: "st27",
    points: "227.5,286.4 227.5,287 240.1,279.7 240.1,279.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1179_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1180_",
    className: "st0",
    points: "225.5,285.1 227.5,286.4 240.1,279.1 238,277.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1177_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1178_",
    className: "st26",
    points: "222.8,286.7 222.8,287.3 224.9,288.5 224.9,287.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1175_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1176_",
    className: "st27",
    points: "224.9,287.9 224.9,288.5 227,287.4 227,286.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1173_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1174_",
    className: "st0",
    points: "222.8,286.7 224.9,287.9 227,286.7 224.9,285.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1171_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1172_",
    className: "st26",
    points: "220.2,288.2 220.2,288.8 222.3,290.1 222.3,289.4  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1169_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1170_",
    className: "st27",
    points: "222.3,289.4 222.3,290.1 224.3,288.9 224.3,288.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1167_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1168_",
    className: "st0",
    points: "220.2,288.2 222.3,289.4 224.3,288.2 222.2,287  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1165_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1166_",
    className: "st26",
    points: "214.9,291.2 214.9,291.9 217,293.1 217,292.4  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1163_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1164_",
    className: "st27",
    points: "217,292.4 217,293.1 221.7,290.4 221.7,289.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1161_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1162_",
    className: "st0",
    points: "214.9,291.2 217,292.4 221.7,289.7 219.6,288.5  "
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1119_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1157_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1158_",
    className: "st24",
    points: "223,231.8 223,242.3 232.1,237 232.1,226.5  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1155_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1156_",
    className: "st28",
    points: "214.3,240.7 214.3,241.2 220.9,237.3 220.9,236.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1153_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1154_",
    className: "st28",
    points: "214.3,239.4 214.3,239.9 220.9,236 220.9,235.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1151_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1152_",
    className: "st28",
    points: "214.3,238.1 214.3,238.5 220.9,234.7 220.9,234.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1149_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1150_",
    className: "st28",
    points: "214.3,236.8 214.3,237.2 220.9,233.4 220.9,233  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1147_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1148_",
    className: "st28",
    points: "214.3,243.4 214.3,243.8 220.9,240 220.9,239.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1145_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1146_",
    className: "st28",
    points: "214.3,242.1 214.3,242.5 220.9,238.7 220.9,238.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1143_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1144_",
    className: "st28",
    points: "216,243.7 216,244.1 220.9,241.3 220.9,240.9  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1141_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1142_",
    className: "st29",
    d: "M230.8,223c-0.2,0.1-0.3,0.3-0.3,0.5s0.1,0.3,0.3,0.2s0.3-0.3,0.3-0.5 S231,222.9,230.8,223z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1135_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1136_",
    className: "st16",
    d: "M233.6,220.8c0.3-0.2,0.6,0,0.6,0.3v2.8c0-0.4-0.2-0.5-0.6-0.3l-21,12.1 c-0.3,0.2-0.6,0.6-0.5,1v-2.8c0-0.4,0.3-0.9,0.6-1L233.6,220.8z M232.1,223c0.2-0.1,0.3-0.3,0.3-0.5s-0.1-0.3-0.3-0.2 s-0.3,0.3-0.3,0.5C231.7,223,231.9,223.1,232.1,223 M230.8,223.8c0.2-0.1,0.3-0.3,0.3-0.5s-0.1-0.3-0.3-0.2s-0.3,0.3-0.3,0.5 S230.6,223.9,230.8,223.8 M233.3,222.3c0.2-0.1,0.3-0.3,0.3-0.5s-0.1-0.3-0.3-0.2s-0.3,0.3-0.3,0.5S233.2,222.4,233.3,222.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1124_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1125_",
    className: "st19",
    d: "M233.7,223.7c0.3-0.2,0.6,0,0.6,0.3v13.7c0,0.3-0.2,0.8-0.5,1l-21,12.1 c-0.3,0.2-0.6,0-0.6-0.3v-13.7c0-0.4,0.2-0.8,0.5-1L233.7,223.7z M223,242.3l9.1-5.3v-10.5l-9.1,5.3V242.3 M214.3,242.5 l6.6-3.8v-0.4l-6.6,3.8V242.5 M214.3,238.5l6.6-3.8v-0.4l-6.6,3.8V238.5 M214.3,239.9l6.6-3.8v-0.4l-6.6,3.8V239.9  M214.3,237.2l6.6-3.8V233l-6.6,3.8V237.2 M214.3,243.8l6.6-3.8v-0.4l-6.6,3.8V243.8 M214.3,241.2l6.6-3.8V237l-6.6,3.8V241.2  M216,244.1l4.9-2.8v-0.4l-4.9,2.8V244.1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1122_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1123_",
    className: "st25",
    d: "M233.3,221.6c-0.2,0.1-0.3,0.3-0.3,0.5s0.1,0.3,0.3,0.2s0.3-0.3,0.3-0.5 C233.6,221.5,233.5,221.5,233.3,221.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1120_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1121_",
    className: "st30",
    d: "M232.1,222.3c-0.2,0.1-0.3,0.3-0.3,0.5s0.1,0.3,0.3,0.2s0.3-0.3,0.3-0.5 C232.4,222.3,232.2,222.2,232.1,222.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1115_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1118_",
    className: "st11",
    d: "M267.2,265.6c0,0.1-0.1,0.2-0.1,0.2c-0.1,0-4.3,2.4-4.3,2.4l-0.7-0.5 c1.2-0.7,3.6-2,5-2.8C267.2,265.2,267.2,265.4,267.2,265.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1117_",
    className: "st6",
    d: "M267.2,265c-1.4,0.8-3.9,2.1-5,2.8l-8.7-5.5c0.8-0.4,1.5-0.8,2.3-1.3c1.4-0.8,3-1.8,4.6-2 c1.2-0.1,2.5,0.3,3.6,1C264.8,260.4,266.9,261.7,267.2,265z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1116_",
    className: "st19",
    d: "M262.6,268.2c0.2,0.1,0.5,0,0.4-0.3c-0.2-3.6-2.5-4.9-3.5-5.5s-4.1-1.8-6.3-0.1 c-0.2,0.1-0.2,0.4,0,0.5C256.6,264.8,261.2,267.4,262.6,268.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_785_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_801_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1113_",
    className: "st11",
    d: "M141.5,203.1L140,204c0.3-0.2,0.4-0.5,0.4-1l1.5-0.9C141.9,202.6,141.7,203,141.5,203.1z "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1105_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1112_",
    className: "st27",
    d: "M98,143.8l1.5-0.9c0.3-0.2,0.6-0.1,1.1,0.1l-1.5,0.9C98.6,143.7,98.3,143.6,98,143.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1106_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1111_",
    className: "st11",
    points: "140.5,169.5 142,168.7 141.9,202.2 140.4,203  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1110_",
    className: "st11",
    points: "99,143.9 100.5,143 140.5,166.1 139,167  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1109_",
    className: "st11",
    d: "M139,167l1.5-0.9c0.8,0.5,1.5,1.6,1.5,2.6l-1.5,0.9C140.5,168.6,139.8,167.5,139,167z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1108_",
    className: "st18",
    d: "M139,167c0.8,0.5,1.5,1.6,1.5,2.6l-0.1,33.5c0,0.9-0.7,1.3-1.5,0.8l-40-23.1 c-0.8-0.5-1.5-1.6-1.5-2.6l0.1-33.5c0-0.9,0.7-1.3,1.5-0.8L139,167z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1107_",
    className: "st24",
    points: "99,147.3 99,177.4 138.9,200.5 139,170.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_802_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1098_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1104_",
    className: "st11",
    d: "M139.6,204.8v1.7c0,0.3-0.2,0.6-0.6,0.9v-1.7C139.4,205.4,139.6,205.1,139.6,204.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1103_",
    className: "st11",
    d: "M110.3,222.2v1.7c-0.8,0.5-2.1,0.5-3,0v-1.7C108.1,222.7,109.5,222.7,110.3,222.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1102_",
    className: "st31",
    d: "M66.7,200v-1.7c0,0.3,0.2,0.6,0.6,0.9v1.7C66.9,200.6,66.7,200.3,66.7,200z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1101_",
    className: "st11",
    points: "138.9,205.6 138.9,207.3 110.3,223.9 110.3,222.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1100_",
    className: "st11",
    points: "107.3,222.2 107.3,223.9 67.3,200.8 67.3,199.1  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1099_",
    className: "st5",
    d: "M138.9,203.9c0.8,0.5,0.8,1.2,0,1.7l-28.7,16.6c-0.8,0.5-2.1,0.5-3,0l-40-23.1 c-0.8-0.5-0.8-1.2,0-1.7L96,180.8c0.8-0.5,2.1-0.5,3,0L138.9,203.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1095_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1096_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1097_",
    className: "st17",
    d: "M106.5,208.2l-14.7-8.5c-0.4-0.2-1.1-0.2-1.5,0l-7.6,4.4c-0.4,0.2-0.4,0.6,0,0.9 l14.7,8.5c0.4,0.2,1.1,0.2,1.5,0l7.6-4.4C106.9,208.8,106.9,208.5,106.5,208.2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_803_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1093_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1094_",
    className: "st10",
    points: "99.4,183.4 99.4,183.8 96.7,185.4 96.7,185  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1091_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1092_",
    className: "st10",
    points: "96.7,185 96.7,185.4 94,183.9 94,183.4  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1089_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1090_",
    className: "st32",
    points: "99.4,183.4 96.7,185 94,183.4 96.7,181.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1087_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1088_",
    className: "st10",
    points: "102.8,185.4 102.8,185.8 100.1,187.4 100.1,186.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1085_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1086_",
    className: "st10",
    points: "100.1,186.9 100.1,187.4 97.4,185.8 97.4,185.4  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1083_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1084_",
    className: "st32",
    points: "102.8,185.4 100.1,186.9 97.4,185.4 100.1,183.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1081_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1082_",
    className: "st10",
    points: "106.2,187.3 106.2,187.8 103.5,189.3 103.5,188.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1079_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1080_",
    className: "st10",
    points: "103.5,188.9 103.5,189.3 100.8,187.8 100.8,187.4  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1077_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1078_",
    className: "st32",
    points: "106.2,187.3 103.5,188.9 100.8,187.4 103.5,185.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1075_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1076_",
    className: "st10",
    points: "109.6,189.3 109.6,189.7 106.9,191.3 106.9,190.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1073_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1074_",
    className: "st10",
    points: "106.9,190.9 106.9,191.3 104.2,189.7 104.2,189.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1071_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1072_",
    className: "st32",
    points: "109.6,189.3 106.9,190.9 104.2,189.3 106.9,187.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1069_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1070_",
    className: "st10",
    points: "113,191.2 113,191.7 110.3,193.2 110.3,192.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1067_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1068_",
    className: "st10",
    points: "110.3,192.8 110.3,193.2 107.6,191.7 107.6,191.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1065_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1066_",
    className: "st32",
    points: "113,191.2 110.3,192.8 107.6,191.3 110.3,189.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1063_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1064_",
    className: "st10",
    points: "116.4,193.2 116.4,193.6 113.7,195.2 113.7,194.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1061_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1062_",
    className: "st10",
    points: "113.7,194.8 113.7,195.2 111,193.7 111,193.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1059_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1060_",
    className: "st32",
    points: "116.4,193.2 113.7,194.8 111,193.2 113.7,191.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1057_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1058_",
    className: "st10",
    points: "119.8,195.2 119.8,195.6 117.1,197.2 117.1,196.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1055_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1056_",
    className: "st10",
    points: "117.1,196.7 117.1,197.2 114.4,195.6 114.4,195.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1053_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1054_",
    className: "st32",
    points: "119.8,195.2 117.1,196.7 114.4,195.2 117.1,193.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1051_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1052_",
    className: "st10",
    points: "123.1,197.1 123.1,197.6 120.5,199.1 120.5,198.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1049_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1050_",
    className: "st10",
    points: "120.5,198.7 120.5,199.1 117.8,197.6 117.8,197.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1047_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1048_",
    className: "st32",
    points: "123.1,197.1 120.5,198.7 117.8,197.2 120.5,195.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1045_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1046_",
    className: "st10",
    points: "126.5,199.1 126.5,199.5 123.9,201.1 123.9,200.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1043_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1044_",
    className: "st10",
    points: "123.9,200.7 123.9,201.1 121.2,199.5 121.2,199.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1041_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1042_",
    className: "st32",
    points: "126.5,199.1 123.9,200.7 121.2,199.1 123.9,197.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1039_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1040_",
    className: "st10",
    points: "129.9,201 129.9,201.5 127.2,203 127.2,202.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1037_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1038_",
    className: "st10",
    points: "127.2,202.6 127.2,203 124.6,201.5 124.6,201.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1035_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1036_",
    className: "st32",
    points: "129.9,201 127.2,202.6 124.6,201.1 127.3,199.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1033_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1034_",
    className: "st10",
    points: "136.7,205 136.7,205.4 134,207 134,206.5  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1031_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1032_",
    className: "st10",
    points: "134,206.5 134,207 128,203.5 128,203  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1029_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1030_",
    className: "st32",
    points: "136.7,205 134,206.5 128,203 130.7,201.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1027_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1028_",
    className: "st10",
    points: "99.4,187.4 99.4,187.8 96.7,189.4 96.7,188.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1025_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1026_",
    className: "st10",
    points: "96.7,188.9 96.7,189.4 90.6,185.9 90.6,185.4  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1023_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1024_",
    className: "st32",
    points: "99.4,187.4 96.7,188.9 90.6,185.4 93.3,183.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1021_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1022_",
    className: "st10",
    points: "102.7,189.3 102.7,189.7 100.1,191.3 100.1,190.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1019_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1020_",
    className: "st10",
    points: "100.1,190.9 100.1,191.3 97.4,189.8 97.4,189.4  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1017_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1018_",
    className: "st32",
    points: "102.7,189.3 100.1,190.9 97.4,189.4 100.1,187.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1015_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1016_",
    className: "st10",
    points: "106.1,191.3 106.1,191.7 103.5,193.3 103.5,192.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1013_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1014_",
    className: "st10",
    points: "103.5,192.8 103.5,193.3 100.8,191.7 100.8,191.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1011_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1012_",
    className: "st32",
    points: "106.1,191.3 103.5,192.8 100.8,191.3 103.5,189.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1009_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1010_",
    className: "st10",
    points: "109.5,193.2 109.5,193.7 106.8,195.2 106.8,194.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1007_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1008_",
    className: "st10",
    points: "106.8,194.8 106.8,195.2 104.2,193.7 104.2,193.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1005_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1006_",
    className: "st32",
    points: "109.5,193.2 106.8,194.8 104.2,193.3 106.9,191.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1003_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1004_",
    className: "st10",
    points: "112.9,195.2 112.9,195.6 110.2,197.2 110.2,196.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1001_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1002_",
    className: "st10",
    points: "110.2,196.8 110.2,197.2 107.6,195.7 107.6,195.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_999_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1000_",
    className: "st32",
    points: "112.9,195.2 110.2,196.8 107.6,195.2 110.3,193.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_997_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_998_",
    className: "st10",
    points: "116.3,197.2 116.3,197.6 113.6,199.1 113.6,198.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_995_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_996_",
    className: "st10",
    points: "113.6,198.7 113.6,199.1 111,197.6 111,197.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_993_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_994_",
    className: "st32",
    points: "116.3,197.2 113.6,198.7 111,197.2 113.7,195.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_991_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_992_",
    className: "st10",
    points: "119.7,199.1 119.7,199.5 117,201.1 117,200.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_989_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_990_",
    className: "st10",
    points: "117,200.7 117,201.1 114.4,199.6 114.4,199.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_987_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_988_",
    className: "st32",
    points: "119.7,199.1 117,200.7 114.4,199.2 117.1,197.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_985_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_986_",
    className: "st10",
    points: "123.1,201.1 123.1,201.5 120.4,203.1 120.4,202.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_983_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_984_",
    className: "st10",
    points: "120.4,202.6 120.4,203.1 117.8,201.5 117.8,201.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_981_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_982_",
    className: "st32",
    points: "123.1,201.1 120.4,202.6 117.8,201.1 120.5,199.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_979_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_980_",
    className: "st10",
    points: "126.5,203 126.5,203.5 123.8,205 123.8,204.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_977_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_978_",
    className: "st10",
    points: "123.8,204.6 123.8,205 121.2,203.5 121.2,203.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_975_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_976_",
    className: "st32",
    points: "126.5,203 123.8,204.6 121.2,203.1 123.9,201.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_973_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_974_",
    className: "st10",
    points: "129.9,205 129.9,205.4 127.2,207 127.2,206.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_971_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_972_",
    className: "st10",
    points: "127.2,206.6 127.2,207 124.6,205.5 124.6,205  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_969_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_970_",
    className: "st32",
    points: "129.9,205 127.2,206.6 124.6,205 127.3,203.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_967_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_968_",
    className: "st10",
    points: "133.3,207 133.3,207.4 130.6,208.9 130.6,208.5  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_965_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_966_",
    className: "st10",
    points: "130.6,208.5 130.6,208.9 128,207.4 128,207  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_963_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_964_",
    className: "st32",
    points: "133.3,207 130.6,208.5 128,207 130.6,205.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_961_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_962_",
    className: "st10",
    points: "95.9,189.4 95.9,189.8 93.2,191.3 93.2,190.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_959_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_960_",
    className: "st10",
    points: "93.2,190.9 93.2,191.3 87.2,187.8 87.2,187.4  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_957_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_958_",
    className: "st32",
    points: "95.9,189.4 93.2,190.9 87.2,187.4 89.9,185.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_955_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_956_",
    className: "st10",
    points: "99.3,191.3 99.3,191.7 96.6,193.3 96.6,192.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_953_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_954_",
    className: "st10",
    points: "96.6,192.9 96.6,193.3 94,191.8 94,191.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_951_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_952_",
    className: "st32",
    points: "99.3,191.3 96.6,192.9 94,191.3 96.7,189.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_949_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_950_",
    className: "st10",
    points: "102.7,193.3 102.7,193.7 100,195.3 100,194.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_947_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_948_",
    className: "st10",
    points: "100,194.8 100,195.3 97.4,193.7 97.4,193.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_945_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_946_",
    className: "st32",
    points: "102.7,193.3 100,194.8 97.4,193.3 100.1,191.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_943_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_944_",
    className: "st10",
    points: "106.1,195.2 106.1,195.7 103.4,197.2 103.4,196.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_941_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_942_",
    className: "st10",
    points: "103.4,196.8 103.4,197.2 100.8,195.7 100.8,195.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_939_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_940_",
    className: "st32",
    points: "106.1,195.2 103.4,196.8 100.8,195.3 103.5,193.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_937_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_938_",
    className: "st10",
    points: "109.5,197.2 109.5,197.6 106.8,199.2 106.8,198.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_935_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_936_",
    className: "st10",
    points: "106.8,198.8 106.8,199.2 104.2,197.6 104.2,197.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_933_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_934_",
    className: "st32",
    points: "109.5,197.2 106.8,198.8 104.2,197.2 106.9,195.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_931_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_932_",
    className: "st10",
    points: "112.9,199.2 112.9,199.6 110.2,201.1 110.2,200.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_929_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_930_",
    className: "st10",
    points: "110.2,200.7 110.2,201.1 107.6,199.6 107.6,199.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_927_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_928_",
    className: "st32",
    points: "112.9,199.2 110.2,200.7 107.6,199.2 110.3,197.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_925_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_926_",
    className: "st10",
    points: "116.3,201.1 116.3,201.5 113.6,203.1 113.6,202.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_923_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_924_",
    className: "st10",
    points: "113.6,202.7 113.6,203.1 111,201.6 111,201.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_921_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_922_",
    className: "st32",
    points: "116.3,201.1 113.6,202.7 111,201.1 113.6,199.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_919_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_920_",
    className: "st10",
    points: "119.7,203.1 119.7,203.5 117,205.1 117,204.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_917_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_918_",
    className: "st10",
    points: "117,204.6 117,205.1 114.3,203.5 114.4,203.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_915_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_916_",
    className: "st32",
    points: "119.7,203.1 117,204.6 114.4,203.1 117,201.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_913_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_914_",
    className: "st10",
    points: "123.1,205 123.1,205.5 120.4,207 120.4,206.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_911_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_912_",
    className: "st10",
    points: "120.4,206.6 120.4,207 117.7,205.5 117.7,205.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_909_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_910_",
    className: "st32",
    points: "123.1,205 120.4,206.6 117.7,205.1 120.4,203.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_907_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_908_",
    className: "st10",
    points: "129.9,209 129.9,209.4 127.2,210.9 127.2,210.5  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_905_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_906_",
    className: "st10",
    points: "127.2,210.5 127.2,210.9 121.1,207.4 121.1,207  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_903_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_904_",
    className: "st32",
    points: "129.9,209 127.2,210.5 121.1,207 123.8,205.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_901_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_902_",
    className: "st10",
    points: "95.9,193.3 95.9,193.7 93.2,195.3 93.2,194.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_899_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_900_",
    className: "st10",
    points: "93.2,194.9 93.2,195.3 83.8,189.8 83.8,189.4  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_897_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_898_",
    className: "st32",
    points: "95.9,193.3 93.2,194.9 83.8,189.4 86.5,187.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_895_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_896_",
    className: "st10",
    points: "99.3,195.3 99.3,195.7 96.6,197.2 96.6,196.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_893_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_894_",
    className: "st10",
    points: "96.6,196.8 96.6,197.2 94,195.7 94,195.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_889_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_892_",
    className: "st32",
    points: "99.3,195.3 96.6,196.8 94,195.3 96.6,193.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_887_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_888_",
    className: "st10",
    points: "102.7,197.2 102.7,197.6 100,199.2 100,198.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_885_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_886_",
    className: "st10",
    points: "100,198.8 100,199.2 97.3,197.7 97.4,197.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_883_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_884_",
    className: "st32",
    points: "102.7,197.2 100,198.8 97.4,197.2 100,195.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_881_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_882_",
    className: "st10",
    points: "106.1,199.2 106.1,199.6 103.4,201.2 103.4,200.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_879_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_880_",
    className: "st10",
    points: "103.4,200.7 103.4,201.2 100.7,199.6 100.7,199.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_876_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_878_",
    className: "st32",
    points: "106.1,199.2 103.4,200.7 100.7,199.2 103.4,197.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_874_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_875_",
    className: "st10",
    points: "109.5,201.1 109.5,201.6 106.8,203.1 106.8,202.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_872_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_873_",
    className: "st10",
    points: "106.8,202.7 106.8,203.1 104.1,201.6 104.1,201.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_870_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_871_",
    className: "st32",
    points: "109.5,201.1 106.8,202.7 104.1,201.2 106.8,199.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_868_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_869_",
    className: "st10",
    points: "112.9,203.1 112.9,203.5 110.2,205.1 110.2,204.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_866_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_867_",
    className: "st10",
    points: "110.2,204.7 110.2,205.1 107.5,203.6 107.5,203.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_864_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_865_",
    className: "st32",
    points: "112.9,203.1 110.2,204.7 107.5,203.1 110.2,201.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_862_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_863_",
    className: "st10",
    points: "116.3,205.1 116.3,205.5 113.6,207 113.6,206.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_860_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_861_",
    className: "st10",
    points: "113.6,206.6 113.6,207 110.9,205.5 110.9,205.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_858_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_859_",
    className: "st32",
    points: "116.3,205.1 113.6,206.6 110.9,205.1 113.6,203.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_856_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_857_",
    className: "st10",
    points: "119.7,207 119.7,207.4 117,209 117,208.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_854_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_855_",
    className: "st10",
    points: "117,208.6 117,209 114.3,207.5 114.3,207.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_852_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_853_",
    className: "st32",
    points: "119.7,207 117,208.6 114.3,207.1 117,205.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_850_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_851_",
    className: "st10",
    points: "126.5,210.9 126.5,211.4 123.8,212.9 123.8,212.5  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_848_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_849_",
    className: "st10",
    points: "123.8,212.5 123.8,212.9 117.7,209.4 117.7,209  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_846_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_847_",
    className: "st32",
    points: "126.5,210.9 123.8,212.5 117.7,209 120.4,207.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_844_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_845_",
    className: "st10",
    points: "85.7,191.4 85.7,191.8 83,193.4 83,192.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_842_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_843_",
    className: "st10",
    points: "83,192.9 83,193.4 80.3,191.8 80.3,191.4  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_840_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_841_",
    className: "st32",
    points: "85.7,191.4 83,192.9 80.3,191.4 83,189.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_838_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_839_",
    className: "st10",
    points: "89.1,193.3 89.1,193.8 86.4,195.3 86.4,194.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_836_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_837_",
    className: "st10",
    points: "86.4,194.9 86.4,195.3 83.7,193.8 83.7,193.4  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_834_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_835_",
    className: "st32",
    points: "89.1,193.3 86.4,194.9 83.7,193.4 86.4,191.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_832_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_833_",
    className: "st10",
    points: "92.5,195.3 92.5,195.7 89.8,197.3 89.8,196.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_830_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_831_",
    className: "st10",
    points: "89.8,196.9 89.8,197.3 87.1,195.8 87.1,195.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_828_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_829_",
    className: "st32",
    points: "92.5,195.3 89.8,196.9 87.1,195.3 89.8,193.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_826_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_827_",
    className: "st10",
    points: "109.4,205.1 109.4,205.5 106.8,207.1 106.8,206.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_824_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_825_",
    className: "st10",
    points: "106.8,206.7 106.8,207.1 90.5,197.7 90.5,197.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_822_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_823_",
    className: "st32",
    points: "109.4,205.1 106.8,206.7 90.5,197.3 93.2,195.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_820_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_821_",
    className: "st10",
    points: "112.8,207.1 112.8,207.5 110.2,209 110.2,208.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_818_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_819_",
    className: "st10",
    points: "110.2,208.6 110.2,209 107.5,207.5 107.5,207.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_816_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_817_",
    className: "st32",
    points: "112.8,207.1 110.2,208.6 107.5,207.1 110.2,205.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_814_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_815_",
    className: "st10",
    points: "116.2,209 116.2,209.4 113.5,211 113.5,210.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_812_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_813_",
    className: "st10",
    points: "113.5,210.6 113.5,211 110.9,209.5 110.9,209  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_810_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_811_",
    className: "st32",
    points: "116.2,209 113.5,210.6 110.9,209 113.6,207.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_808_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_809_",
    className: "st10",
    points: "123,212.9 123,213.4 120.3,214.9 120.3,214.5  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_806_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_807_",
    className: "st10",
    points: "120.3,214.5 120.3,214.9 114.3,211.4 114.3,211  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_804_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_805_",
    className: "st32",
    points: "123,212.9 120.3,214.5 114.3,211 117,209.4  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_786_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_800_",
    className: "st1",
    points: "103.7,176.1 134.6,194 134.6,171.7 134.6,171.7 103.7,153.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_799_",
    className: "st17",
    points: "132.5,173.8 121.5,167.4 121.5,182.9 132.5,189.3  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_790_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_798_",
    className: "st24",
    points: "106.7,159.8 119.1,167 119.1,166.1 106.7,158.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_797_",
    className: "st24",
    points: "106.7,161.9 119.1,169.1 119.1,168.2 106.7,161  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_796_",
    className: "st24",
    points: "106.7,164 119.1,171.2 119.1,170.3 106.7,163.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_795_",
    className: "st24",
    points: "106.7,166.1 119.1,173.3 119.1,172.4 106.7,165.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_794_",
    className: "st24",
    points: "106.7,168.2 119.1,175.4 119.1,174.5 106.7,167.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_793_",
    className: "st24",
    points: "106.7,170.3 119.1,177.5 119.1,176.6 106.7,169.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_792_",
    className: "st24",
    points: "106.7,174.6 115.4,179.5 115.4,178.6 106.7,173.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_791_",
    className: "st24",
    points: "106.7,172.4 119.1,179.6 119.1,178.7 106.7,171.5  "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_789_",
    className: "st16",
    points: "126.1,171.5 122.8,176.1 129.3,179.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_788_",
    className: "st11",
    points: "128.7,174.3 125.4,179 131.9,182.8  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_787_",
    className: "st18",
    d: "M131.2,183.9c0,1.6-1.1,2.3-2.5,1.5c-1.4-0.8-2.5-2.8-2.5-4.4c0-1.6,1.1-2.3,2.5-1.5 C130.1,180.3,131.2,182.3,131.2,183.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_778_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_782_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_784_",
    className: "st24",
    points: "245.4,122.2 248.8,126 250.4,123.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_783_",
    className: "st6",
    points: "245.4,122.2 246.3,123.2 246.8,122.4  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_781_",
    className: "st6",
    d: "M250.4,123.1c-0.2-0.1-0.5-0.1-0.8,0.1c-0.6,0.4-1.2,1.3-1.2,2c0,0.4,0.1,0.6,0.3,0.7 l24.4,14.2c-0.2-0.1-0.3-0.4-0.3-0.7c0-0.7,0.5-1.6,1.2-2c0.3-0.2,0.6-0.2,0.8-0.1L250.4,123.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_779_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_780_",
    className: "st11",
    d: "M274,137.4c0.6-0.4,1.2-0.1,1.2,0.7c0,0.7-0.5,1.6-1.2,2c-0.6,0.4-1.2,0.1-1.2-0.7 C272.8,138.7,273.3,137.8,274,137.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_771_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_775_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_777_",
    className: "st24",
    points: "257,124.2 260.4,128 262,125.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_776_",
    className: "st15",
    points: "257,124.2 258,125.3 258.4,124.5  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_774_",
    className: "st15",
    d: "M262,125.2c-0.2-0.1-0.5-0.1-0.8,0.1c-0.6,0.4-1.2,1.3-1.2,2c0,0.4,0.1,0.6,0.3,0.7 l15.8,9.2c-0.2-0.1-0.3-0.4-0.3-0.7c0-0.7,0.5-1.6,1.2-2c0.3-0.2,0.6-0.2,0.8-0.1L262,125.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_772_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_773_",
    className: "st16",
    d: "M277,134.4c0.6-0.4,1.2-0.1,1.2,0.7c0,0.7-0.5,1.6-1.2,2c-0.6,0.4-1.2,0.1-1.2-0.7 C275.8,135.7,276.3,134.8,277,134.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_762_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_770_",
    className: "st20",
    d: "M241.4,129.5c-0.2-0.1-0.2-0.2-0.2-0.3v3.1c0,0.1,0.1,0.3,0.2,0.3l3.4,2v-3.1L241.4,129.5z "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_769_",
    className: "st33",
    points: "249.5,128.9 249.5,131.9 244.9,134.6 244.9,131.5  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_768_",
    className: "st30",
    d: "M249.5,128.9l-4.6,2.7l-3.4-2c-0.3-0.2-0.3-0.5,0-0.7l3.4-2c0.3-0.2,0.9-0.2,1.2,0 L249.5,128.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_767_",
    className: "st34",
    points: "251.9,130.3 251.9,133.3 247.3,136 247.3,132.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_766_",
    className: "st35",
    points: "247.3,132.9 247.3,136 244.9,134.6 244.9,131.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_765_",
    className: "st24",
    points: "251.9,130.3 247.3,132.9 244.9,131.5 249.5,128.9  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_764_",
    className: "st11",
    d: "M255.3,132.9l-3.4,2c-0.3,0.2-0.9,0.2-1.2,0l-3.4-2v3.1l3.4,2c0.3,0.2,0.9,0.2,1.2,0l3.4-2 c0.2-0.1,0.2-0.2,0.2-0.3v-3.1C255.5,132.7,255.5,132.8,255.3,132.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_763_",
    className: "st6",
    d: "M255.3,132.2c0.3,0.2,0.3,0.5,0,0.7l-3.4,2c-0.3,0.2-0.9,0.2-1.2,0l-3.4-2l4.6-2.7 L255.3,132.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_738_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_761_",
    className: "st24",
    d: "M209.1,103.6l-49,28.3c-1.1,0.7-1,1.8,0.3,2.6l28.4,16.4c1.3,0.8,3.3,0.8,4.4,0.2l49-28.3 c1.1-0.7,1-1.8-0.3-2.6l-28.4-16.4C212.3,103,210.3,102.9,209.1,103.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_755_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_760_",
    className: "st36",
    points: "213.4,112.7 216.7,110.9 235.4,121.7 232.2,123.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_759_",
    className: "st36",
    points: "206.6,116.7 209.8,114.8 228.5,125.7 225.3,127.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_758_",
    className: "st36",
    points: "199.7,120.7 202.9,118.8 221.6,129.6 218.4,131.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_757_",
    className: "st36",
    points: "192.8,124.7 196,122.8 214.7,133.6 211.5,135.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_756_",
    className: "st36",
    points: "185.9,128.6 189.1,126.8 207.8,137.6 204.6,139.5  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_749_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_754_",
    className: "st1",
    points: "213.4,112.7 216.7,110.9 221.3,113.6 218.1,115.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_753_",
    className: "st19",
    points: "206.6,116.7 209.8,114.8 220.7,121.1 217.5,123  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_752_",
    className: "st6",
    points: "199.7,120.7 202.9,118.8 210.9,123.4 207.6,125.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_751_",
    className: "st11",
    points: "192.8,124.7 196,122.8 209.5,130.6 206.3,132.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_750_",
    className: "st15",
    points: "185.9,128.6 189.1,126.8 205,136 201.8,137.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_740_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_748_",
    className: "st36",
    points: "200.2,140.5 189.7,146.5 191.1,147.3 201.5,141.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_747_",
    className: "st36",
    points: "197,138.7 186.6,144.7 188,145.5 198.4,139.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_746_",
    className: "st36",
    points: "193.9,136.9 183.5,142.9 184.8,143.7 195.3,137.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_745_",
    className: "st36",
    points: "190.8,135.1 180.4,141.1 181.7,141.9 192.1,135.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_744_",
    className: "st36",
    points: "187.7,133.3 177.2,139.3 178.6,140.1 189,134  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_743_",
    className: "st36",
    points: "184.5,131.5 174.1,137.5 175.5,138.3 185.9,132.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_742_",
    className: "st36",
    points: "178.3,127.8 171,132 172.4,132.8 179.6,128.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_741_",
    className: "st36",
    points: "181.4,129.7 171,135.7 172.3,136.5 182.8,130.4  "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_739_",
    className: "st36",
    points: "213.4,109 182.6,126.7 184,127.5 214.7,109.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_734_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_737_",
    className: "st6",
    points: "211.8,147.4 233.8,134.7 246.2,141.9 224.3,154.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_736_",
    className: "st11",
    points: "224.3,154.6 226.7,143.3 246.2,141.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_735_",
    className: "st19",
    points: "233.8,134.7 231.3,145.9 211.8,147.4  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_718_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_733_",
    className: "st24",
    points: "333,164.1 370.9,186 323.1,213.6 285.2,191.7  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_722_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_732_",
    className: "st23",
    d: "M322.8,191.9L322.8,191.9L322.8,191.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_731_",
    className: "st25",
    d: "M322.8,191.9L322.8,191.9L322.8,191.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_730_",
    className: "st19",
    d: "M322.8,191.9l-5.2-8.3c-2.1,0.4-4,1.1-5.6,2L322.8,191.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_729_",
    className: "st1",
    d: "M322.8,191.9l10.9-6.3c-4.3-2.5-10.7-3.2-16.1-2L322.8,191.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_728_",
    className: "st6",
    d: "M311.9,198.2l10.9-6.3l-15.2-1.1C306.9,193.5,308.6,196.2,311.9,198.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_727_",
    className: "st11",
    d: "M328,200.2c2.1-0.4,4-1.1,5.6-2c6-3.4,6-9.1,0-12.5l-10.9,6.3L328,200.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_723_",
    className: "st15",
    d: "M328,200.2l-5.2-8.3l-10.9,6.3C316.2,200.7,322.6,201.3,328,200.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_721_",
    className: "st1",
    d: "M353.7,190.9c-0.1,0-0.1,0-0.2-0.1L325,174.4c-0.2-0.1-0.3-0.4-0.2-0.6 c0.1-0.2,0.4-0.3,0.6-0.2l28.5,16.5c0.2,0.1,0.3,0.4,0.2,0.6C354,190.9,353.8,190.9,353.7,190.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_720_",
    className: "st1",
    d: "M357,189c-0.1,0-0.1,0-0.2-0.1l-28.5-16.5c-0.2-0.1-0.3-0.4-0.2-0.6 c0.1-0.2,0.4-0.3,0.6-0.2l28.5,16.5c0.2,0.1,0.3,0.4,0.2,0.6C357.3,188.9,357.2,189,357,189z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_719_",
    className: "st1",
    d: "M360.4,187.1c-0.1,0-0.1,0-0.2-0.1l-28.5-16.5c-0.2-0.1-0.3-0.4-0.2-0.6 c0.1-0.2,0.4-0.3,0.6-0.2l28.5,16.5c0.2,0.1,0.3,0.4,0.2,0.6C360.7,187,360.5,187.1,360.4,187.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_704_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_716_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_717_",
    className: "st16",
    d: "M363.3,215.4v5.3c0,0.7-0.5,1.4-1.4,1.9v-5.3C362.8,216.8,363.3,216.1,363.3,215.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_714_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_715_",
    className: "st15",
    d: "M309.8,220.7v-5.3c0,0.7,0.5,1.4,1.4,2v5.3C310.2,222.1,309.8,221.4,309.8,220.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_711_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_713_",
    className: "st16",
    points: "361.9,217.3 361.8,222.6 340,235.3 340,230  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_709_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_710_",
    className: "st15",
    points: "333.2,230 333.2,235.3 311.2,222.6 311.2,217.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_707_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_708_",
    className: "st15",
    d: "M340,230v5.3c-0.9,0.6-2.2,0.8-3.4,0.8s-2.4-0.3-3.4-0.8V230c0.9,0.5,2.2,0.8,3.4,0.8 S339,230.6,340,230z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_705_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_706_",
    className: "st17",
    d: "M361.8,213.4c1.9,1.1,1.9,2.8,0,3.9L340,230c-1.9,1.1-4.9,1.1-6.8,0l-22-12.7 c-1.9-1.1-1.9-2.8,0-3.9l21.9-12.7c1.9-1.1,4.9-1.1,6.8,0L361.8,213.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_691_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_702_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_703_",
    className: "st18",
    d: "M407.3,200.3v5.3c0,0.7-0.5,1.4-1.4,1.9v-5.3C406.9,201.7,407.3,201,407.3,200.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_700_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_701_",
    className: "st18",
    d: "M353.8,205.6v-5.3c0,0.7,0.5,1.4,1.4,2v5.3C354.3,207,353.8,206.3,353.8,205.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_698_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_699_",
    className: "st18",
    points: "405.9,202.2 405.9,207.5 384,220.3 384,215  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_696_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_697_",
    className: "st18",
    points: "377.3,215 377.3,220.3 355.2,207.5 355.3,202.2  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_694_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_695_",
    className: "st18",
    d: "M384,215v5.3c-0.9,0.6-2.2,0.8-3.4,0.8c-1.2,0-2.5-0.3-3.4-0.8V215 c0.9,0.5,2.2,0.8,3.4,0.8C381.9,215.8,383.1,215.5,384,215z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_692_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_693_",
    className: "st6",
    d: "M405.9,198.3c1.9,1.1,1.9,2.8,0,3.9L384,215c-1.9,1.1-4.9,1.1-6.8,0l-22-12.7 c-1.9-1.1-1.9-2.8,0-3.9l21.9-12.7c1.9-1.1,4.9-1.1,6.8,0L405.9,198.3z"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "XMLID_690_",
    transform: "matrix(-0.866 -0.5 0.866 -0.5 351.2433 219.2129)",
    className: "st24 st37 st38"
  }, "DATA"), /*#__PURE__*/React.createElement("text", {
    id: "XMLID_689_",
    transform: "matrix(-0.866 -0.5 0.866 -0.5 397.4933 205.6152)",
    className: "st24 st37 st39"
  }, "DATA"), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_688_",
    className: "st18",
    d: "M380.7,215.8v5.3c-1.2,0-2.5-0.3-3.4-0.8V215C378.2,215.5,379.5,215.8,380.7,215.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_687_",
    className: "st16",
    d: "M340,230v5.3c-0.9,0.6-2.2,0.8-3.4,0.8v-5.3C337.8,230.8,339,230.6,340,230z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_673_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_674_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_686_",
    className: "st8",
    d: "M388.3,191.4c-4.2,1.9-8.1,16-5.8,21c2.3,5,6,5.3,10.6,4.1s9.9-7.3,11.6-13 C407.1,195.8,400.4,186.1,388.3,191.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_676_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_677_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_685_",
    className: "st40",
    d: "M383.4,361.6v1.1c-2.2,1.3-7.2,0.6-8.5,0c-0.9-1.3-3.2-1-4.5-0.4 c-5,0.4-6.8-0.3-8.5-1.5c-0.8-0.6-2.4-2.2-2.2-3.9C365.7,358.2,383.4,361.6,383.4,361.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_684_",
    className: "st11",
    d: "M374.9,352.9c0,0-5.4,1.5-8.7,2c-3.2,0.5-5.5-0.1-6.3,1.1s0.9,4.1,3.8,5.1 c2.8,1,8.7-0.2,10.8,0.3c2.1,0.5,7.6,1.5,8.9,0.1c1.3-1.3,0-7.9,0-7.9L374.9,352.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_683_",
    className: "st10",
    d: "M405,345.8l-9.7-10.9c-3.9-1.1-8-1.3-7.5,2.2c0.5,3.2,5.5,4.6,9,7.7l3.2,2.9 C402.4,349.7,405.3,347.9,405,345.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_682_",
    className: "st8",
    d: "M395.8,209.1c-0.4,0.4-0.8,0.8-1.2,1.1c-2.5,1.9-5,3.1-8,3.9c-0.5,0.1-1,0.2-1.6,0.3 l0.2,2.8c3.3,0.9,6.5-0.5,8.8-1.1c1.7-0.5,4.3-0.9,4.3-2.7L395.8,209.1L395.8,209.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_681_",
    className: "st40",
    d: "M400.1,347.6l-3.2-2.9c-3.5-3.1-8.5-4.5-9-7.7l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0c-0.1,0.3-0.1,0.7,0,1.1c0.5,3.2,5.5,4.6,9,7.7 l3.2,2.9c2.7,2.4,5.6,0.7,5-2.9C405.3,347.9,402.4,349.7,400.1,347.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_680_",
    className: "st11",
    d: "M405,270c3.4,4.8-5,17.9-2.7,34.4c1.6,11.1,4.6,29.8,3.9,40.4c-0.1,1.9-7.6,3.3-9.7-6 c-3.5-15.8-7.8-25.7-9.3-37.9l0.8-35.6L405,270z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_679_",
    className: "st11",
    d: "M394.2,268.2c0.9,14.8-9.7,32.9-9,44.8c0.7,12.3-0.6,27.3-0.7,40.6 c0,0-10.9,5.2-11.4-2.8c-1.6-26.1-6.6-34.2,0.1-82L394.2,268.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_678_",
    className: "st6",
    d: "M374.5,253.9c-0.4-14.2,2.3-28.3,2.3-28.3c1.3-1.8,2.8-3.4,4.6-4.7l3.5-4.2 c2.5-0.6,4.9-1.3,7.3-2c3.9-1.2,8.1-1.2,12,0l0,0c5.1,2.2,6.1,5.6,3.8,12.3c0.1,0.3-4.5,18.5-5.1,24.1 c-0.1,0.5,3.9,15.3,4.8,21.3c0,0-3.8,3.4-4.8,4.3c-7.6,9.5-32.6-2-33.5-7.1C369.1,267.7,372.1,261.9,374.5,253.9z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_675_",
    className: "st4",
    d: "M386.8,192.3c0,0-1.2,1.1-2,3.6s-0.6,4.1-0.6,5.4c-0.1,1.3-0.6,2-0.3,2.6 c0.3,0.6,1.8-2.8,3.3-3.2s1.3,4.1-2,5.3c-1.4,2.1-0.3,7.3,0.5,8.4c0.8,1.1,5.6,2.6,9.6,1.2c4-1.4,6.7-5.5,10.1-10.8 c3.3-5.3,0-9.2,0-9.2c1.7-3.7-10.9-8.4-16.1-8.5C385.9,187.1,386.8,192.3,386.8,192.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_671_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_672_",
    className: "st5",
    d: "M392.7,229.2c1.6-5.6-4.6-12.5-10.1-10.7c-2,0.7-3.6,1.3-4.7,3c-2.6,4.3-3,19-5.1,27.9 c-0.3,0.1-0.7,0.1-1,0.2c3.4,4.6,5,6.9,8,11.1c0.3-0.1,0.5-0.2,0.6-0.2C381.3,260,392.6,229.3,392.7,229.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_625_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_670_",
    className: "st10",
    d: "M132.8,400l9.1-0.8c0,0,5.9,1.6,9.3,2.1c3.5,0.5,5.9-0.1,6.8,1.2c0.1,0.2,0.2,0.5,0.2,0.8 l0,0l0,0l0,0c0.2,1.8-1.4,3.5-2.3,4.2c-1.8,1.3-3.7,2.1-9.1,1.6c-1.4-0.6-3.9-0.9-4.8,0.5c-1.4,0.7-6.8,1.4-9.1,0v-1.2 C131.4,407,132.8,400,132.8,400z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_669_",
    className: "st4",
    d: "M128.8,315.8c-3,15.6,7.8,32.6,6.9,45.2c-1.2,17.2-1.9,24.8-3.6,38.8c0,0,7,4.2,12.2-0.6 c5.3-27.5,7.6-32.4,6.9-82.7L128.8,315.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_666_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_668_",
    className: "st22",
    d: "M171.3,244.2c3.1,3.6,0.5,18.4-3.8,22s-7.9,2.3-11.7-0.9c-3.8-3.2-6-11.2-5.1-17.2 C151.9,240,162.5,233.9,171.3,244.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_667_",
    className: "st13",
    d: "M172.4,245.7c0,0,0.7,1.6,0.3,4.2c-0.4,2.6-1.3,4.1-1.8,5.3s-0.3,2.1-0.8,2.6 s-0.4-3.4-1.7-4.4c-1.2-1-3,3.2-0.5,5.8c0.4,2.6-3,6.9-4.2,7.6s-6.3-0.1-9.4-3.2c-3.1-3.1-3.8-8.1-4.6-14.5 c-0.7-6.4,4.1-8.6,4.1-8.6c0.1-4.1,13.8-3,18.7-0.8C175.4,241.3,172.4,245.7,172.4,245.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_665_",
    className: "st10",
    d: "M150.3,408.3l9.1-0.8c0,0,5.9,1.6,9.3,2.1c3.5,0.5,5.9-0.1,6.8,1.2 c0.1,0.2,0.2,0.5,0.2,0.8l0,0l0,0l0,0c0.2,1.8-1.4,3.5-2.3,4.2c-1.8,1.3-3.7,2.1-9.1,1.6c-1.4-0.6-3.9-0.9-4.8,0.5 c-1.4,0.7-6.8,1.4-9.1,0v-1.2C148.9,415.3,150.3,408.3,150.3,408.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_664_",
    className: "st4",
    d: "M135.7,319.7c-1,15.9,12,33.2,12.8,46.1c1,17.6,1.1,30,1.1,44.3c0,0,11.7,5.5,12.2-3 c1.7-28,3.6-35.4-3.7-86.7L135.7,319.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_663_",
    className: "st5",
    d: "M166.3,268.8c-6.5-3.3-17.1-12.2-25.7-0.5c-8.1,10.9-11.4,43.8-12.4,50.3 c-1.3,8.9,23.5,13.6,29,13.4c1.2-0.1,2-0.6,2.4-1.9c0.5-1.6-0.9-2.8-0.5-4.3c0.2-0.9,0.8-1.6,1.3-2.3c0.5-0.7,1.1-1.4,1.2-2.3 c0.2-1.4-0.7-2.7-0.8-4.1c-0.1-1,0.2-2.1,0.4-3.1c2.2-8.3,6.1-16.1,8.3-24.5c1.5-5.7,3.6-14.7-1.1-19.4 C167.8,269.7,167,269,166.3,268.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_662_",
    className: "st6",
    d: "M170.3,273.2c5.2,16.6,5.7,24.8,10.8,31.3c0.4,0.5,14.5,15.6,14.5,15.6s-1.9,3.4-6.8,4.3 c-7.9-3.4-16.8-15.8-19.2-18.5c-1.4-1.5-9.2-15.8-10.3-23.1C158.1,275.7,168.1,266.7,170.3,273.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M371.8,261.7c5.6-0.4,8.6-1.2,8.6-1.2s6.9-14.8,8.8-21.9c0,0-2.5,15.2-4.2,20.1c-1.7,4.9-4,6.9-7.6,6.4 c-3.6-0.4-6.4-1.2-6.4-1.2L371.8,261.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.6,345c2.3,0.1,4.6,0.2,6.9,0.2c0.6,0,1.3-0.2,1.7,0.1c0.6,0.4,0.8,1.9,1,2.6c0.3,0.9,1.1,2.6,1,3.5 c0.1-1.1,0.1-3.7,0.9-4.9c0.7,0.7,1.2,1.7,1.8,2.4c-0.1-1.1,0-1.9,0.4-2.9c0.6,0.7,1.9,0.9,2.8,1.2c4.2,1.7,9,4.3,11.4,8.3 c2.6,4.4-1.5,9.1-4.7,12c-1.6,1.4-3.5,2.7-5.5,3.5c-0.7,0.3-3.8,0.7-3.8,1.9c-0.6-0.7-1.1-1.5-1.8-2.1c0,0.7-0.6,1.4-0.4,2 c-1.2,0.4-2.5,0.2-3.7,0.8c-0.3-1.3-1.5-2.4-1.9-3.7c-0.5,1-1,2.2-1.2,3.4c-0.8-0.2-1.6-0.1-2.4-0.1c-3.4,0.1-6.9-0.2-10.2-0.7 c-2.1-0.3-4.1-0.3-6.1-0.4c-0.1-1.2-0.7-2.5-1-3.6c-0.3-1.5-0.6-3-1-4.5c-0.4,0.5-0.4,1.1-0.6,1.7c-0.6,1.9-1.4,3.9-2.1,5.7 c-0.7-0.4-8.5-1.2-8.4-1.7c0.1-1.3,0.3-3.1,0.1-4.3c-0.5,1.2-1.4,2.1-2.2,3.2c-0.8-1.3-0.3-4.2-0.6-5.7c-0.8,0.6-1,1.8-1.5,2.6 c-0.3,0.6-0.9,1.1-0.9,1.8c-1.9-0.9-3.6-2.1-5.3-3.2c-1.1-0.7-3.3-1.6-4-2.8c-0.5-0.8-0.1-2.2-0.5-3c-0.6,0.3-0.8,0.9-1.1,1.4 c-0.4-0.3-5.8-4.4-5.5-4.8c2.8-3.1,5.6-5.9,9.4-7.8c0.7-0.3,1.4-0.9,2.1-0.7c1.4,0.5,2.4,2.5,3.5,3.3c-0.4-1.7-0.2-3.7-0.3-5.4 c2-0.5,3.7-0.9,5.8-1c1.8,0,3.7-0.2,5.4-0.1c0.6,0.1,1.9-0.1,2.5,0.2c1.5,0.6,2.5,5.1,2.9,6.7c0.8-1.5,0.5-3.7,1.3-5.4 c0.9-1.7,2.5-0.6,3.7-1.1c-0.4,0.7,0.2,2.1,0.4,2.8c0.4-0.7,0.4-1.8,1.1-2.3c0.9,1.5,1.7,3,2.2,4.7c0.6-0.9,0.5-2.1,0.9-3.1 c0.2-0.5,0.5-0.9,0.7-1.4c2.1,0.4,4.3,0.3,6.4,0.4C85.4,345,85.5,345,85.6,345z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.1,355.4c3.1-0.7,7.1,0.5,10.2,1.1c3.4,0.6,6.7,1.2,10.1,1.8c6.3,1.1,12.6,1.9,18.9,1.9 c13,0,26.3,0.9,39.2-1.2c0.9-0.1,0.8-1.7-0.1-1.6c-13.3,1-26.6,1.8-39.9,1.9c-6.8,0-13.6-1-20.3-2.1c-6-1-12.2-2.3-18.3-2.5 C42.4,354.6,42.4,355.6,43.1,355.4L43.1,355.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.f58629e260eca58f19b300f2c7dfaa08.svg";
export { ForwardRef as ReactComponent };